const allAttributes = [
  {
    "parentOlxId": 937,
    "olxId": 1843,
    "name": "broj-rupa",
    "displayName": "Broj rupa",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi broj rupa"
      },
      {
        "value": 1,
        "label": "3"
      },
      {
        "value": 2,
        "label": "4"
      },
      {
        "value": 3,
        "label": "5"
      },
      {
        "value": 4,
        "label": "Više"
      }
    ]
  },
  {
    "parentOlxId": 937,
    "olxId": 1840,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Čelične"
      },
      {
        "value": 2,
        "label": "Aluminijske"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 937,
    "olxId": 1842,
    "name": "raspon-sarafa",
    "displayName": "Raspon šarafa",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi raspon šarafa"
      },
      {
        "value": 1,
        "label": "4x98"
      },
      {
        "value": 2,
        "label": "4x100"
      },
      {
        "value": 3,
        "label": "4x108"
      },
      {
        "value": 4,
        "label": "4x112"
      },
      {
        "value": 5,
        "label": "4x114.3"
      },
      {
        "value": 6,
        "label": "4x113.30"
      },
      {
        "value": 7,
        "label": "4x120"
      },
      {
        "value": 8,
        "label": "5x98"
      },
      {
        "value": 9,
        "label": "5x100"
      },
      {
        "value": 10,
        "label": "5x105"
      },
      {
        "value": 11,
        "label": "5x114.3"
      },
      {
        "value": 12,
        "label": "5x108"
      },
      {
        "value": 13,
        "label": "5x110"
      },
      {
        "value": 14,
        "label": "5x112"
      },
      {
        "value": 15,
        "label": "5x115"
      },
      {
        "value": 16,
        "label": "5x120"
      },
      {
        "value": 17,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 937,
    "olxId": 1839,
    "name": "velicina-inch",
    "displayName": "Veličina (inch)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličina (inch)"
      },
      {
        "value": 1,
        "label": "13"
      },
      {
        "value": 2,
        "label": "14"
      },
      {
        "value": 3,
        "label": "15"
      },
      {
        "value": 4,
        "label": "16"
      },
      {
        "value": 5,
        "label": "17"
      },
      {
        "value": 6,
        "label": "18"
      },
      {
        "value": 7,
        "label": "19"
      },
      {
        "value": 8,
        "label": "20"
      },
      {
        "value": 9,
        "label": "21"
      },
      {
        "value": 10,
        "label": "22"
      },
      {
        "value": 11,
        "label": "23"
      },
      {
        "value": 12,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 938,
    "olxId": 2912,
    "name": "kontrola",
    "displayName": "Kontrola",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi kontrola"
      },
      {
        "value": 1,
        "label": "Touchscreen"
      },
      {
        "value": 2,
        "label": "Tipke"
      },
      {
        "value": 3,
        "label": "Touchsceen + tipke"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 938,
    "olxId": 2915,
    "name": "memorija-gb",
    "displayName": "Memorija (GB)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi memorija (gb)"
      },
      {
        "value": 1,
        "label": "1"
      },
      {
        "value": 2,
        "label": "2"
      },
      {
        "value": 3,
        "label": "3"
      },
      {
        "value": 4,
        "label": "4"
      },
      {
        "value": 5,
        "label": "6"
      },
      {
        "value": 6,
        "label": "8"
      },
      {
        "value": 7,
        "label": "16"
      },
      {
        "value": 8,
        "label": "32"
      },
      {
        "value": 9,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 938,
    "olxId": 2914,
    "name": "ram",
    "displayName": "RAM",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi ram"
      },
      {
        "value": 1,
        "label": "64"
      },
      {
        "value": 2,
        "label": "128"
      },
      {
        "value": 3,
        "label": "256"
      },
      {
        "value": 4,
        "label": "348"
      },
      {
        "value": 5,
        "label": "512"
      },
      {
        "value": 6,
        "label": "768"
      },
      {
        "value": 7,
        "label": "1024 (1GB)"
      },
      {
        "value": 8,
        "label": "1.5 GB"
      },
      {
        "value": 9,
        "label": "2 GB"
      },
      {
        "value": 10,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 938,
    "olxId": 2913,
    "name": "velicina-ekrana-inch",
    "displayName": "Veličina ekrana (inch)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličina ekrana (inch)"
      },
      {
        "value": 1,
        "label": "1"
      },
      {
        "value": 2,
        "label": "1.1"
      },
      {
        "value": 3,
        "label": "1.5"
      },
      {
        "value": 4,
        "label": "1.6"
      },
      {
        "value": 5,
        "label": "1.7"
      },
      {
        "value": 6,
        "label": "2"
      },
      {
        "value": 7,
        "label": "2.1"
      },
      {
        "value": 8,
        "label": "2.2"
      },
      {
        "value": 9,
        "label": "2.3"
      },
      {
        "value": 10,
        "label": "2.4"
      },
      {
        "value": 11,
        "label": "2.6"
      },
      {
        "value": 12,
        "label": "2.7"
      },
      {
        "value": 13,
        "label": "2.8"
      },
      {
        "value": 14,
        "label": "3"
      },
      {
        "value": 15,
        "label": "3.5"
      },
      {
        "value": 16,
        "label": "3.8"
      },
      {
        "value": 17,
        "label": "4"
      },
      {
        "value": 18,
        "label": "4.3"
      },
      {
        "value": 19,
        "label": "4.4"
      },
      {
        "value": 20,
        "label": "4.7"
      },
      {
        "value": 21,
        "label": "5"
      },
      {
        "value": 22,
        "label": "5.1"
      },
      {
        "value": 23,
        "label": "5.8"
      },
      {
        "value": 24,
        "label": "7"
      },
      {
        "value": 25,
        "label": "8"
      },
      {
        "value": 26,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 939,
    "olxId": 1847,
    "name": "sijalica",
    "displayName": "Sijalica",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi sijalica"
      },
      {
        "value": 1,
        "label": "Obična"
      },
      {
        "value": 2,
        "label": "Xenon"
      },
      {
        "value": 3,
        "label": "BiXenon"
      },
      {
        "value": 4,
        "label": "LED"
      },
      {
        "value": 5,
        "label": "HID"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 939,
    "olxId": 2121,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Far desni"
      },
      {
        "value": 2,
        "label": "Far lijevi"
      },
      {
        "value": 3,
        "label": "Oba fara"
      },
      {
        "value": 4,
        "label": "Štopka desna"
      },
      {
        "value": 5,
        "label": "Štopka lijeva"
      },
      {
        "value": 6,
        "label": "Obje štopke"
      },
      {
        "value": 7,
        "label": "Dnevna svjetla DRL"
      },
      {
        "value": 8,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 940,
    "olxId": 2918,
    "name": "sirina",
    "displayName": "Širina",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi širina"
      },
      {
        "value": 1,
        "label": "135"
      },
      {
        "value": 2,
        "label": "145"
      },
      {
        "value": 3,
        "label": "155"
      },
      {
        "value": 4,
        "label": "165"
      },
      {
        "value": 5,
        "label": "175"
      },
      {
        "value": 6,
        "label": "185"
      },
      {
        "value": 7,
        "label": "195"
      },
      {
        "value": 8,
        "label": "205"
      },
      {
        "value": 9,
        "label": "215"
      },
      {
        "value": 10,
        "label": "225"
      },
      {
        "value": 11,
        "label": "235"
      },
      {
        "value": 12,
        "label": "245"
      },
      {
        "value": 13,
        "label": "255"
      },
      {
        "value": 14,
        "label": "265"
      },
      {
        "value": 15,
        "label": "275"
      },
      {
        "value": 16,
        "label": "285"
      },
      {
        "value": 17,
        "label": "295"
      },
      {
        "value": 18,
        "label": "305"
      },
      {
        "value": 19,
        "label": "315"
      },
      {
        "value": 20,
        "label": "325"
      },
      {
        "value": 21,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 940,
    "olxId": 1849,
    "name": "velicina-precnik-promjer",
    "displayName": "Veličina (prečnik/promjer)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličina (prečnik/promjer)"
      },
      {
        "value": 1,
        "label": "13"
      },
      {
        "value": 2,
        "label": "14"
      },
      {
        "value": 3,
        "label": "15"
      },
      {
        "value": 4,
        "label": "16"
      },
      {
        "value": 5,
        "label": "17"
      },
      {
        "value": 6,
        "label": "18"
      },
      {
        "value": 7,
        "label": "19"
      },
      {
        "value": 8,
        "label": "20"
      },
      {
        "value": 9,
        "label": "21"
      },
      {
        "value": 10,
        "label": "22"
      },
      {
        "value": 11,
        "label": "23"
      },
      {
        "value": 12,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 940,
    "olxId": 2919,
    "name": "visina",
    "displayName": "Visina",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi visina"
      },
      {
        "value": 1,
        "label": "25"
      },
      {
        "value": 2,
        "label": "30"
      },
      {
        "value": 3,
        "label": "35"
      },
      {
        "value": 4,
        "label": "40"
      },
      {
        "value": 5,
        "label": "45"
      },
      {
        "value": 6,
        "label": "50"
      },
      {
        "value": 7,
        "label": "55"
      },
      {
        "value": 8,
        "label": "60"
      },
      {
        "value": 9,
        "label": "65"
      },
      {
        "value": 10,
        "label": "70"
      },
      {
        "value": 11,
        "label": "75"
      },
      {
        "value": 12,
        "label": "80"
      },
      {
        "value": 13,
        "label": "85"
      },
      {
        "value": 14,
        "label": "90"
      },
      {
        "value": 15,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 940,
    "olxId": 1848,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Ljetne"
      },
      {
        "value": 2,
        "label": "Zimske"
      },
      {
        "value": 3,
        "label": "All season (Cjelogodišnje)"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 941,
    "olxId": 4736,
    "name": "pozicija-namjena",
    "displayName": "Pozicija/Namjena",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi pozicija/namjena"
      },
      {
        "value": 1,
        "label": "Lijevo prednje"
      },
      {
        "value": 2,
        "label": "Desno prednje"
      },
      {
        "value": 3,
        "label": "Komplet prednja"
      },
      {
        "value": 4,
        "label": "Komplet zadnja"
      },
      {
        "value": 5,
        "label": "Prednja i zadnja"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 942,
    "olxId": 2794,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Pranje"
      },
      {
        "value": 2,
        "label": "Poliranje"
      },
      {
        "value": 3,
        "label": "Sjaj"
      },
      {
        "value": 4,
        "label": "Miris"
      },
      {
        "value": 5,
        "label": "Sprej"
      },
      {
        "value": 6,
        "label": "Krpa"
      },
      {
        "value": 7,
        "label": "Osvježivač"
      },
      {
        "value": 8,
        "label": "Marker"
      },
      {
        "value": 9,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 943,
    "olxId": 1852,
    "name": "boja",
    "displayName": "Boja",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi boju"
      },
      {
        "value": 1,
        "label": "Neutralna"
      },
      {
        "value": 2,
        "label": "Bež"
      },
      {
        "value": 3,
        "label": "Bijela"
      },
      {
        "value": 4,
        "label": "Crna"
      },
      {
        "value": 5,
        "label": "Crvena"
      },
      {
        "value": 6,
        "label": "Krom"
      },
      {
        "value": 7,
        "label": "Ljubičasta"
      },
      {
        "value": 8,
        "label": "Narandžasta"
      },
      {
        "value": 9,
        "label": "Plava"
      },
      {
        "value": 10,
        "label": "Siva"
      },
      {
        "value": 11,
        "label": "Smeđa"
      },
      {
        "value": 12,
        "label": "Srebrena"
      },
      {
        "value": 13,
        "label": "Zelena"
      },
      {
        "value": 14,
        "label": "Zlatna"
      },
      {
        "value": 15,
        "label": "Žuta"
      },
      {
        "value": 16,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 943,
    "olxId": 2124,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Desni"
      },
      {
        "value": 2,
        "label": "Lijevi"
      },
      {
        "value": 3,
        "label": "Unutrašnji"
      },
      {
        "value": 4,
        "label": "Univerzalni"
      },
      {
        "value": 5,
        "label": "Desni i Lijevi (set)"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 944,
    "olxId": 1856,
    "name": "boja",
    "displayName": "Boja",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi boju"
      },
      {
        "value": 1,
        "label": "Neutralna"
      },
      {
        "value": 2,
        "label": "Bež"
      },
      {
        "value": 3,
        "label": "Bijela"
      },
      {
        "value": 4,
        "label": "Crna"
      },
      {
        "value": 5,
        "label": "Crvena"
      },
      {
        "value": 6,
        "label": "Ljubičasta"
      },
      {
        "value": 7,
        "label": "Narandžasta"
      },
      {
        "value": 8,
        "label": "Plava"
      },
      {
        "value": 9,
        "label": "Siva"
      },
      {
        "value": 10,
        "label": "Smeđa"
      },
      {
        "value": 11,
        "label": "Srebrena"
      },
      {
        "value": 12,
        "label": "Zelena"
      },
      {
        "value": 13,
        "label": "Zlatna"
      },
      {
        "value": 14,
        "label": "Žuta"
      },
      {
        "value": 15,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 944,
    "olxId": 2123,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Branik prednji"
      },
      {
        "value": 2,
        "label": "Branik zadnji"
      },
      {
        "value": 3,
        "label": "Spojler prednji"
      },
      {
        "value": 4,
        "label": "Spojler zadnji"
      },
      {
        "value": 5,
        "label": "Spojler gepeka"
      },
      {
        "value": 6,
        "label": "Spojler zadnje šajbe"
      },
      {
        "value": 7,
        "label": "Spojler krovni"
      },
      {
        "value": 8,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 945,
    "olxId": 2504,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Čelik"
      },
      {
        "value": 2,
        "label": "Aluminizirani Čelik"
      },
      {
        "value": 3,
        "label": "Inox"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 945,
    "olxId": 1858,
    "name": "proizvodnja",
    "displayName": "Proizvodnja",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi proizvodnja"
      },
      {
        "value": 1,
        "label": "Fabrička"
      },
      {
        "value": 2,
        "label": "Ručna"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 948,
    "olxId": 8035,
    "name": "tip-tuninga",
    "displayName": "Tip tuninga",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi tip tuninga"
      },
      {
        "value": 1,
        "label": "Performanse"
      },
      {
        "value": 2,
        "label": "Vizualni tuning"
      },
      {
        "value": 3,
        "label": "Racing"
      },
      {
        "value": 4,
        "label": "Daily tuning"
      },
      {
        "value": 5,
        "label": "Off road tuning"
      },
      {
        "value": 6,
        "label": "OEM stil"
      }
    ]
  },
  {
    "parentOlxId": 948,
    "olxId": 2798,
    "name": "vrsta",
    "displayName": "Vrsta dijela",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta dijela"
      },
      {
        "value": 1,
        "label": "Motor i usis"
      },
      {
        "value": 2,
        "label": "Turbo i prisilno punjenje"
      },
      {
        "value": 3,
        "label": "Izduvni sistem"
      },
      {
        "value": 4,
        "label": "Ovjes i stabilnost"
      },
      {
        "value": 5,
        "label": "Kočioni sistem"
      },
      {
        "value": 6,
        "label": "Točkovi i gume"
      },
      {
        "value": 7,
        "label": "Eksterijer"
      },
      {
        "value": 8,
        "label": "Aerodinamika"
      },
      {
        "value": 9,
        "label": "Interijer"
      },
      {
        "value": 10,
        "label": "Multimedija"
      },
      {
        "value": 11,
        "label": "Elektronika"
      },
      {
        "value": 12,
        "label": "Hlađenje"
      },
      {
        "value": 13,
        "label": "Univerzalni dijelovi"
      },
      {
        "value": 14,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 949,
    "olxId": 2850,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Osovina"
      },
      {
        "value": 2,
        "label": "Signalizacija (Svjetlosna)"
      },
      {
        "value": 3,
        "label": "Kočnice"
      },
      {
        "value": 4,
        "label": "Felge"
      },
      {
        "value": 5,
        "label": "Gume"
      },
      {
        "value": 6,
        "label": "Točkovi komplet"
      },
      {
        "value": 7,
        "label": "Amortizeri"
      },
      {
        "value": 8,
        "label": "Nosači"
      },
      {
        "value": 9,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 950,
    "olxId": 1862,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Čelične"
      },
      {
        "value": 2,
        "label": "Aluminijske"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 950,
    "olxId": 1861,
    "name": "velicina",
    "displayName": "Veličina",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličinu"
      },
      {
        "value": 1,
        "label": "9"
      },
      {
        "value": 2,
        "label": "10"
      },
      {
        "value": 3,
        "label": "11"
      },
      {
        "value": 4,
        "label": "12"
      },
      {
        "value": 5,
        "label": "13"
      },
      {
        "value": 6,
        "label": "14"
      },
      {
        "value": 7,
        "label": "15"
      },
      {
        "value": 8,
        "label": "16"
      },
      {
        "value": 9,
        "label": "17"
      },
      {
        "value": 10,
        "label": "18"
      },
      {
        "value": 11,
        "label": "19"
      },
      {
        "value": 12,
        "label": "20"
      },
      {
        "value": 13,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 952,
    "olxId": 1869,
    "name": "sijalica",
    "displayName": "Sijalica",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi sijalica"
      },
      {
        "value": 1,
        "label": "Obična"
      },
      {
        "value": 2,
        "label": "Xenon"
      },
      {
        "value": 3,
        "label": "BiXenon"
      },
      {
        "value": 4,
        "label": "LED"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 952,
    "olxId": 2773,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Prednja"
      },
      {
        "value": 2,
        "label": "Zadnja"
      },
      {
        "value": 3,
        "label": "Prednja i zadnja"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 953,
    "olxId": 1871,
    "name": "promjer-inch",
    "displayName": "Promjer (inch)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi promjer (inch)"
      },
      {
        "value": 1,
        "label": "10"
      },
      {
        "value": 2,
        "label": "11"
      },
      {
        "value": 3,
        "label": "12"
      },
      {
        "value": 4,
        "label": "13"
      },
      {
        "value": 5,
        "label": "14"
      },
      {
        "value": 6,
        "label": "15"
      },
      {
        "value": 7,
        "label": "16"
      },
      {
        "value": 8,
        "label": "17"
      },
      {
        "value": 9,
        "label": "18"
      },
      {
        "value": 10,
        "label": "19"
      },
      {
        "value": 11,
        "label": "20"
      },
      {
        "value": 12,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 953,
    "olxId": 1870,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Ljetne"
      },
      {
        "value": 2,
        "label": "Zimske"
      },
      {
        "value": 3,
        "label": "Blato Zima"
      },
      {
        "value": 4,
        "label": "Ljeto Zima"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 956,
    "olxId": 2776,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Lijevi"
      },
      {
        "value": 2,
        "label": "Desni"
      },
      {
        "value": 3,
        "label": "Lijevi i Desni"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 957,
    "olxId": 1877,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Plastika"
      },
      {
        "value": 2,
        "label": "Aluminij"
      },
      {
        "value": 3,
        "label": "Karbonska vlakna"
      },
      {
        "value": 4,
        "label": "Poliester"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 957,
    "olxId": 1876,
    "name": "proizvodnja",
    "displayName": "Proizvodnja",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi proizvodnja"
      },
      {
        "value": 1,
        "label": "Fabrički"
      },
      {
        "value": 2,
        "label": "Ručni (custom)"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 958,
    "olxId": 1880,
    "name": "proizvodnja",
    "displayName": "Proizvodnja",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi proizvodnja"
      },
      {
        "value": 1,
        "label": "Fabrički"
      },
      {
        "value": 2,
        "label": "Ručni (custom)"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 962,
    "olxId": 1884,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Čelične"
      },
      {
        "value": 2,
        "label": "Aluminijske"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 962,
    "olxId": 1883,
    "name": "velicina-inch",
    "displayName": "Veličina (inch)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličina (inch)"
      },
      {
        "value": 1,
        "label": "13"
      },
      {
        "value": 2,
        "label": "14"
      },
      {
        "value": 3,
        "label": "14.5"
      },
      {
        "value": 4,
        "label": "15"
      },
      {
        "value": 5,
        "label": "15.5"
      },
      {
        "value": 6,
        "label": "16"
      },
      {
        "value": 7,
        "label": "17"
      },
      {
        "value": 8,
        "label": "17.5"
      },
      {
        "value": 9,
        "label": "18"
      },
      {
        "value": 10,
        "label": "19"
      },
      {
        "value": 11,
        "label": "19.5"
      },
      {
        "value": 12,
        "label": "20"
      },
      {
        "value": 13,
        "label": "21"
      },
      {
        "value": 14,
        "label": "22"
      },
      {
        "value": 15,
        "label": "24"
      },
      {
        "value": 16,
        "label": "26"
      },
      {
        "value": 17,
        "label": "28"
      },
      {
        "value": 18,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 963,
    "olxId": 2892,
    "name": "kontrola",
    "displayName": "Kontrola",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi kontrola"
      },
      {
        "value": 1,
        "label": "Touchscreen"
      },
      {
        "value": 2,
        "label": "Tipke"
      },
      {
        "value": 3,
        "label": "Touchsceen + tipke"
      }
    ]
  },
  {
    "parentOlxId": 963,
    "olxId": 2861,
    "name": "velicina-ekrana-inch",
    "displayName": "Veličina ekrana (inch)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličina ekrana (inch)"
      },
      {
        "value": 1,
        "label": "1"
      },
      {
        "value": 2,
        "label": "1.1"
      },
      {
        "value": 3,
        "label": "1.5"
      },
      {
        "value": 4,
        "label": "1.6"
      },
      {
        "value": 5,
        "label": "1.7"
      },
      {
        "value": 6,
        "label": "2"
      },
      {
        "value": 7,
        "label": "2.1"
      },
      {
        "value": 8,
        "label": "2.2"
      },
      {
        "value": 9,
        "label": "2.3"
      },
      {
        "value": 10,
        "label": "2.4"
      },
      {
        "value": 11,
        "label": "2.6"
      },
      {
        "value": 12,
        "label": "2.7"
      },
      {
        "value": 13,
        "label": "2.8"
      },
      {
        "value": 14,
        "label": "3"
      },
      {
        "value": 15,
        "label": "3.5"
      },
      {
        "value": 16,
        "label": "3.8"
      },
      {
        "value": 17,
        "label": "4"
      },
      {
        "value": 18,
        "label": "4.3"
      },
      {
        "value": 19,
        "label": "4.4"
      },
      {
        "value": 20,
        "label": "4.7"
      },
      {
        "value": 21,
        "label": "5"
      },
      {
        "value": 22,
        "label": "5.1"
      },
      {
        "value": 23,
        "label": "5.8"
      },
      {
        "value": 24,
        "label": "7"
      },
      {
        "value": 25,
        "label": "8"
      },
      {
        "value": 26,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 963,
    "olxId": 2862,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Fabrička/Originalna"
      },
      {
        "value": 2,
        "label": "Prenosiva/Portabilna"
      }
    ]
  },
  {
    "parentOlxId": 964,
    "olxId": 1891,
    "name": "sijalica",
    "displayName": "Sijalica",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi sijalica"
      },
      {
        "value": 1,
        "label": "Obična"
      },
      {
        "value": 2,
        "label": "Xenon"
      },
      {
        "value": 3,
        "label": "BiXenon"
      },
      {
        "value": 4,
        "label": "LED"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 964,
    "olxId": 2856,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Lijevi prednji"
      },
      {
        "value": 2,
        "label": "Desni prednji"
      },
      {
        "value": 3,
        "label": "Lijevi zadnji"
      },
      {
        "value": 4,
        "label": "Desni zadnji"
      },
      {
        "value": 5,
        "label": "Lijevi prednji i zadnji"
      },
      {
        "value": 6,
        "label": "Desni prednji i zadnji"
      },
      {
        "value": 7,
        "label": "Lijevi i Desni (prednji)"
      },
      {
        "value": 8,
        "label": "Lijevi i Desni (zadnji)"
      },
      {
        "value": 9,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 965,
    "olxId": 2851,
    "name": "sirina",
    "displayName": "Širina",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi širina"
      },
      {
        "value": 1,
        "label": "6.00"
      },
      {
        "value": 2,
        "label": "6.50"
      },
      {
        "value": 3,
        "label": "7.50"
      },
      {
        "value": 4,
        "label": "8.25"
      },
      {
        "value": 5,
        "label": "8.50"
      },
      {
        "value": 6,
        "label": "9.00"
      },
      {
        "value": 7,
        "label": "9.50"
      },
      {
        "value": 8,
        "label": "10.00"
      },
      {
        "value": 9,
        "label": "10.50"
      },
      {
        "value": 10,
        "label": "11.00"
      },
      {
        "value": 11,
        "label": "12.00"
      },
      {
        "value": 12,
        "label": "12.50"
      },
      {
        "value": 13,
        "label": "13.00"
      },
      {
        "value": 14,
        "label": "14.00"
      },
      {
        "value": 15,
        "label": "16.00"
      },
      {
        "value": 16,
        "label": "24.00"
      },
      {
        "value": 17,
        "label": "165"
      },
      {
        "value": 18,
        "label": "175"
      },
      {
        "value": 19,
        "label": "185"
      },
      {
        "value": 20,
        "label": "195"
      },
      {
        "value": 21,
        "label": "205"
      },
      {
        "value": 22,
        "label": "215"
      },
      {
        "value": 23,
        "label": "225"
      },
      {
        "value": 24,
        "label": "235"
      },
      {
        "value": 25,
        "label": "245"
      },
      {
        "value": 26,
        "label": "255"
      },
      {
        "value": 27,
        "label": "265"
      },
      {
        "value": 28,
        "label": "275"
      },
      {
        "value": 29,
        "label": "285"
      },
      {
        "value": 30,
        "label": "295"
      },
      {
        "value": 31,
        "label": "305"
      },
      {
        "value": 32,
        "label": "315"
      },
      {
        "value": 33,
        "label": "325"
      },
      {
        "value": 34,
        "label": "355"
      },
      {
        "value": 35,
        "label": "365"
      },
      {
        "value": 36,
        "label": "385"
      },
      {
        "value": 37,
        "label": "395"
      },
      {
        "value": 38,
        "label": "425"
      },
      {
        "value": 39,
        "label": "435"
      },
      {
        "value": 40,
        "label": "445"
      },
      {
        "value": 41,
        "label": "455"
      },
      {
        "value": 42,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 965,
    "olxId": 1893,
    "name": "velicina-promjer",
    "displayName": "Veličina/Promjer",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličina/promjer"
      },
      {
        "value": 1,
        "label": "13"
      },
      {
        "value": 2,
        "label": "14"
      },
      {
        "value": 3,
        "label": "14.5"
      },
      {
        "value": 4,
        "label": "15"
      },
      {
        "value": 5,
        "label": "15.5"
      },
      {
        "value": 6,
        "label": "16"
      },
      {
        "value": 7,
        "label": "17"
      },
      {
        "value": 8,
        "label": "17.5"
      },
      {
        "value": 9,
        "label": "18"
      },
      {
        "value": 10,
        "label": "19"
      },
      {
        "value": 11,
        "label": "19.5"
      },
      {
        "value": 12,
        "label": "20"
      },
      {
        "value": 13,
        "label": "21"
      },
      {
        "value": 14,
        "label": "22"
      },
      {
        "value": 15,
        "label": "22.5"
      },
      {
        "value": 16,
        "label": "24"
      },
      {
        "value": 17,
        "label": "26"
      },
      {
        "value": 18,
        "label": "28"
      },
      {
        "value": 19,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 965,
    "olxId": 2853,
    "name": "visina",
    "displayName": "Visina",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi visina"
      },
      {
        "value": 1,
        "label": "50"
      },
      {
        "value": 2,
        "label": "55"
      },
      {
        "value": 3,
        "label": "60"
      },
      {
        "value": 4,
        "label": "65"
      },
      {
        "value": 5,
        "label": "70"
      },
      {
        "value": 6,
        "label": "75"
      },
      {
        "value": 7,
        "label": "80"
      },
      {
        "value": 8,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 968,
    "olxId": 2886,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Lijevi"
      },
      {
        "value": 2,
        "label": "Desni"
      },
      {
        "value": 3,
        "label": "Lijevi i Desni"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 971,
    "olxId": 1903,
    "name": "vrsta-formati",
    "displayName": "Vrsta/Formati",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta/formati"
      },
      {
        "value": 1,
        "label": "Kasetofon"
      },
      {
        "value": 2,
        "label": "CD"
      },
      {
        "value": 3,
        "label": "CD MP3"
      },
      {
        "value": 4,
        "label": "CD MP3 plus pojačalo"
      },
      {
        "value": 5,
        "label": "DVD MP3 plus LCD display"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 974,
    "olxId": 1906,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Čelične"
      },
      {
        "value": 2,
        "label": "Aluminijske"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 974,
    "olxId": 3172,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Prednja"
      },
      {
        "value": 2,
        "label": "Zadnja"
      },
      {
        "value": 3,
        "label": "Prednja i Zadnja"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 974,
    "olxId": 3168,
    "name": "velicina-inch",
    "displayName": "Veličina (inch)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličina (inch)"
      },
      {
        "value": 1,
        "label": "12"
      },
      {
        "value": 2,
        "label": "14"
      },
      {
        "value": 3,
        "label": "16"
      },
      {
        "value": 4,
        "label": "20"
      },
      {
        "value": 5,
        "label": "24"
      },
      {
        "value": 6,
        "label": "26"
      },
      {
        "value": 7,
        "label": "27"
      },
      {
        "value": 8,
        "label": "28"
      },
      {
        "value": 9,
        "label": "29"
      },
      {
        "value": 10,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 976,
    "olxId": 3036,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "LED"
      },
      {
        "value": 2,
        "label": "Obične"
      },
      {
        "value": 3,
        "label": "Katadiopter"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 977,
    "olxId": 1915,
    "name": "velicina-inch",
    "displayName": "Veličina (inch)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličina (inch)"
      },
      {
        "value": 1,
        "label": "12"
      },
      {
        "value": 2,
        "label": "14"
      },
      {
        "value": 3,
        "label": "16"
      },
      {
        "value": 4,
        "label": "20"
      },
      {
        "value": 5,
        "label": "24"
      },
      {
        "value": 6,
        "label": "26"
      },
      {
        "value": 7,
        "label": "27"
      },
      {
        "value": 8,
        "label": "28"
      },
      {
        "value": 9,
        "label": "29"
      },
      {
        "value": 10,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 980,
    "olxId": 3206,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Lijevi"
      },
      {
        "value": 2,
        "label": "Desni"
      },
      {
        "value": 3,
        "label": "Lijevi i Desni (komplet)"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 981,
    "olxId": 3207,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Prednji"
      },
      {
        "value": 2,
        "label": "Zadnji"
      },
      {
        "value": 3,
        "label": "Cijeli set"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 986,
    "olxId": 1928,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Čelične"
      },
      {
        "value": 2,
        "label": "Aluminijske"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 988,
    "olxId": 2922,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Desni far"
      },
      {
        "value": 2,
        "label": "Lijevi far"
      },
      {
        "value": 3,
        "label": "Desna štopka"
      },
      {
        "value": 4,
        "label": "Lijeva štopka"
      },
      {
        "value": 5,
        "label": "Komplet farovi"
      },
      {
        "value": 6,
        "label": "Komplet štopke"
      },
      {
        "value": 7,
        "label": "Farovi i štopke (komplet)"
      },
      {
        "value": 8,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 994,
    "olxId": 2934,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Čelik"
      },
      {
        "value": 2,
        "label": "Aluminizirani Čelik"
      },
      {
        "value": 3,
        "label": "Inox"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 995,
    "olxId": 1947,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Kasetofon"
      },
      {
        "value": 2,
        "label": "CD"
      },
      {
        "value": 3,
        "label": "CD MP3"
      },
      {
        "value": 4,
        "label": "CD MP3 plus pojačalo"
      },
      {
        "value": 5,
        "label": "DVD MP3 plus LCD display"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 998,
    "olxId": 1951,
    "name": "boja",
    "displayName": "Boja",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi boju"
      },
      {
        "value": 1,
        "label": "Siva"
      },
      {
        "value": 2,
        "label": "Crna"
      },
      {
        "value": 3,
        "label": "Krom"
      },
      {
        "value": 4,
        "label": "Crno Siva"
      },
      {
        "value": 5,
        "label": "Crno Krom"
      },
      {
        "value": 6,
        "label": "Bež"
      },
      {
        "value": 7,
        "label": "Bijela"
      },
      {
        "value": 8,
        "label": "Crvena"
      },
      {
        "value": 9,
        "label": "Ljubičasta"
      },
      {
        "value": 10,
        "label": "Narandžasta"
      },
      {
        "value": 11,
        "label": "Plava"
      },
      {
        "value": 12,
        "label": "Smeđa"
      },
      {
        "value": 13,
        "label": "Srebrena"
      },
      {
        "value": 14,
        "label": "Zelena"
      },
      {
        "value": 15,
        "label": "Zlatna"
      },
      {
        "value": 16,
        "label": "Žuta"
      }
    ]
  },
  {
    "parentOlxId": 998,
    "olxId": 1950,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Čelične"
      },
      {
        "value": 2,
        "label": "Aluminijske"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1000,
    "olxId": 2867,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Desna"
      },
      {
        "value": 2,
        "label": "Lijeva"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1000,
    "olxId": 2870,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Far"
      },
      {
        "value": 2,
        "label": "Štopka"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1001,
    "olxId": 1958,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Ljetne"
      },
      {
        "value": 2,
        "label": "Zimske"
      },
      {
        "value": 3,
        "label": "All season"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1002,
    "olxId": 2882,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Vozačevo"
      },
      {
        "value": 2,
        "label": "Putničko"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1004,
    "olxId": 2883,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Desni"
      },
      {
        "value": 2,
        "label": "Lijevi"
      },
      {
        "value": 3,
        "label": "Unutrašnji"
      },
      {
        "value": 4,
        "label": "Univerzalni"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1005,
    "olxId": 1965,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Plastika"
      },
      {
        "value": 2,
        "label": "Aluminij"
      },
      {
        "value": 3,
        "label": "Karbonska vlakna"
      },
      {
        "value": 4,
        "label": "Poliester"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1005,
    "olxId": 2888,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Prednji"
      },
      {
        "value": 2,
        "label": "Zadnji"
      },
      {
        "value": 3,
        "label": "Bočni"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1006,
    "olxId": 2890,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Čelik"
      },
      {
        "value": 2,
        "label": "Aluminizirani Čelik"
      },
      {
        "value": 3,
        "label": "Inox"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1007,
    "olxId": 1969,
    "name": "radio",
    "displayName": "Radio",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi radio"
      },
      {
        "value": 1,
        "label": "Kasetofon"
      },
      {
        "value": 2,
        "label": "CD"
      },
      {
        "value": 3,
        "label": "CD MP3"
      },
      {
        "value": 4,
        "label": "CD MP3 plus pojačalo"
      },
      {
        "value": 5,
        "label": "DVD MP3 plus LCD display"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1034,
    "olxId": 2801,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Šajba"
      },
      {
        "value": 2,
        "label": "Vrata"
      },
      {
        "value": 3,
        "label": "Gepek"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1035,
    "olxId": 2936,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Prednja šajba"
      },
      {
        "value": 2,
        "label": "Zadnja šajba"
      },
      {
        "value": 3,
        "label": "Lijevi prednji prozor"
      },
      {
        "value": 4,
        "label": "Desni prednji prozor"
      },
      {
        "value": 5,
        "label": "Lijevi komplet"
      },
      {
        "value": 6,
        "label": "Desni komplet"
      },
      {
        "value": 7,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1035,
    "olxId": 2935,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Prednja"
      },
      {
        "value": 2,
        "label": "Vrata"
      },
      {
        "value": 3,
        "label": "Bočni"
      },
      {
        "value": 4,
        "label": "Zadnja"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1036,
    "olxId": 2898,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Prednja"
      },
      {
        "value": 2,
        "label": "Vrata"
      },
      {
        "value": 3,
        "label": "Bočni"
      },
      {
        "value": 4,
        "label": "Zadnja"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1037,
    "olxId": 2906,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Prednja"
      },
      {
        "value": 2,
        "label": "Zadnja"
      },
      {
        "value": 3,
        "label": "Prednja i zadnja"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1041,
    "olxId": 2793,
    "name": "spol",
    "displayName": "Spol",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi spol"
      },
      {
        "value": 1,
        "label": "Muški"
      },
      {
        "value": 2,
        "label": "Ženski"
      },
      {
        "value": 3,
        "label": "Unisex"
      }
    ]
  },
  {
    "parentOlxId": 1041,
    "olxId": 2037,
    "name": "velicina-i-obim",
    "displayName": "Veličina i obim",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličina i obim"
      },
      {
        "value": 1,
        "label": "XXXS (49/50 cm)"
      },
      {
        "value": 2,
        "label": "XXS (51/52 cm)"
      },
      {
        "value": 3,
        "label": "XS (53/54 cm)"
      },
      {
        "value": 4,
        "label": "S (55/56 cm)"
      },
      {
        "value": 5,
        "label": "M (57/58 cm)"
      },
      {
        "value": 6,
        "label": "L (59/60 cm)"
      },
      {
        "value": 7,
        "label": "XL (61/62 cm)"
      },
      {
        "value": 8,
        "label": "XXL (63/64 cm)"
      },
      {
        "value": 9,
        "label": "XXXL (65/66 cm)"
      },
      {
        "value": 10,
        "label": "4XL (67/68 cm)"
      },
      {
        "value": 11,
        "label": "5XL (69/70 cm)"
      },
      {
        "value": 12,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1061,
    "olxId": 2433,
    "name": "godiste",
    "displayName": "Godište",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi godište"
      },
      {
        "value": 1,
        "label": "2026"
      },
      {
        "value": 2,
        "label": "2025"
      },
      {
        "value": 3,
        "label": "2024"
      },
      {
        "value": 4,
        "label": "2023"
      },
      {
        "value": 5,
        "label": "2022"
      },
      {
        "value": 6,
        "label": "2021"
      },
      {
        "value": 7,
        "label": "2020"
      },
      {
        "value": 8,
        "label": "2019"
      },
      {
        "value": 9,
        "label": "2018"
      },
      {
        "value": 10,
        "label": "2017"
      },
      {
        "value": 11,
        "label": "2016"
      },
      {
        "value": 12,
        "label": "2015"
      },
      {
        "value": 13,
        "label": "2014"
      },
      {
        "value": 14,
        "label": "2013"
      },
      {
        "value": 15,
        "label": "2012"
      },
      {
        "value": 16,
        "label": "2011"
      },
      {
        "value": 17,
        "label": "2010"
      },
      {
        "value": 18,
        "label": "2009"
      },
      {
        "value": 19,
        "label": "2008"
      },
      {
        "value": 20,
        "label": "2007"
      },
      {
        "value": 21,
        "label": "2006"
      },
      {
        "value": 22,
        "label": "2005"
      },
      {
        "value": 23,
        "label": "2004"
      },
      {
        "value": 24,
        "label": "2003"
      },
      {
        "value": 25,
        "label": "2002"
      },
      {
        "value": 26,
        "label": "2001"
      },
      {
        "value": 27,
        "label": "2000"
      },
      {
        "value": 28,
        "label": "1999"
      },
      {
        "value": 29,
        "label": "1998"
      },
      {
        "value": 30,
        "label": "1997"
      },
      {
        "value": 31,
        "label": "1996"
      },
      {
        "value": 32,
        "label": "1995"
      },
      {
        "value": 33,
        "label": "1994"
      },
      {
        "value": 34,
        "label": "1993"
      },
      {
        "value": 35,
        "label": "1992"
      },
      {
        "value": 36,
        "label": "1991"
      },
      {
        "value": 37,
        "label": "1990"
      },
      {
        "value": 38,
        "label": "1989"
      },
      {
        "value": 39,
        "label": "1988"
      },
      {
        "value": 40,
        "label": "1987"
      },
      {
        "value": 41,
        "label": "1986"
      },
      {
        "value": 42,
        "label": "1985"
      },
      {
        "value": 43,
        "label": "1984"
      },
      {
        "value": 44,
        "label": "1983"
      },
      {
        "value": 45,
        "label": "1982"
      },
      {
        "value": 46,
        "label": "1981"
      },
      {
        "value": 47,
        "label": "1980"
      },
      {
        "value": 48,
        "label": "1979"
      },
      {
        "value": 49,
        "label": "1978"
      },
      {
        "value": 50,
        "label": "1977"
      },
      {
        "value": 51,
        "label": "1976"
      },
      {
        "value": 52,
        "label": "1975"
      },
      {
        "value": 53,
        "label": "1974"
      },
      {
        "value": 54,
        "label": "1973"
      },
      {
        "value": 55,
        "label": "1972"
      },
      {
        "value": 56,
        "label": "1971"
      },
      {
        "value": 57,
        "label": "1970"
      },
      {
        "value": 58,
        "label": "1969"
      },
      {
        "value": 59,
        "label": "1968"
      },
      {
        "value": 60,
        "label": "1967"
      },
      {
        "value": 61,
        "label": "1966"
      },
      {
        "value": 62,
        "label": "1965"
      },
      {
        "value": 63,
        "label": "1964"
      },
      {
        "value": 64,
        "label": "1963"
      },
      {
        "value": 65,
        "label": "1962"
      },
      {
        "value": 66,
        "label": "1961"
      },
      {
        "value": 67,
        "label": "1960"
      },
      {
        "value": 68,
        "label": "Starije"
      }
    ]
  },
  {
    "parentOlxId": 1061,
    "olxId": 2432,
    "name": "gorivo",
    "displayName": "Gorivo",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi gorivo"
      },
      {
        "value": 1,
        "label": "Dizel"
      },
      {
        "value": 2,
        "label": "Benzin"
      },
      {
        "value": 3,
        "label": "Plin"
      },
      {
        "value": 4,
        "label": "Hibrid"
      },
      {
        "value": 5,
        "label": "Elektro"
      }
    ]
  },
  {
    "parentOlxId": 1061,
    "olxId": 2429,
    "name": "kubikaza",
    "displayName": "Kubikaža",
    "inputType": "select-range",
    "options": [
      {
        "value": 0,
        "label": "Izaberi kubikaža"
      },
      {
        "value": 1,
        "label": "0.8"
      },
      {
        "value": 2,
        "label": "0.9"
      },
      {
        "value": 3,
        "label": "1.0"
      },
      {
        "value": 4,
        "label": "1.1"
      },
      {
        "value": 5,
        "label": "1.2"
      },
      {
        "value": 6,
        "label": "1.3"
      },
      {
        "value": 7,
        "label": "1.4"
      },
      {
        "value": 8,
        "label": "1.5"
      },
      {
        "value": 9,
        "label": "1.6"
      },
      {
        "value": 10,
        "label": "1.7"
      },
      {
        "value": 11,
        "label": "1.8"
      },
      {
        "value": 12,
        "label": "1.9"
      },
      {
        "value": 13,
        "label": "2.0"
      },
      {
        "value": 14,
        "label": "2.2"
      },
      {
        "value": 15,
        "label": "2.3"
      },
      {
        "value": 16,
        "label": "2.4"
      },
      {
        "value": 17,
        "label": "2.5"
      },
      {
        "value": 18,
        "label": "2.6"
      },
      {
        "value": 19,
        "label": "2.7"
      },
      {
        "value": 20,
        "label": "2.8"
      },
      {
        "value": 21,
        "label": "2.9"
      },
      {
        "value": 22,
        "label": "3.0"
      },
      {
        "value": 23,
        "label": "3.2"
      },
      {
        "value": 24,
        "label": "3.3"
      },
      {
        "value": 25,
        "label": "3.4"
      },
      {
        "value": 26,
        "label": "3.5"
      },
      {
        "value": 27,
        "label": "3.6"
      },
      {
        "value": 28,
        "label": "3.7"
      },
      {
        "value": 29,
        "label": "3.8"
      },
      {
        "value": 30,
        "label": "3.9"
      },
      {
        "value": 31,
        "label": "4.0"
      },
      {
        "value": 32,
        "label": "4.2"
      },
      {
        "value": 33,
        "label": "4.3"
      },
      {
        "value": 34,
        "label": "4.4"
      },
      {
        "value": 35,
        "label": "4.5"
      },
      {
        "value": 36,
        "label": "4.6"
      },
      {
        "value": 37,
        "label": "4.7"
      },
      {
        "value": 38,
        "label": "4.8"
      },
      {
        "value": 39,
        "label": "4.9"
      },
      {
        "value": 40,
        "label": "5.0"
      },
      {
        "value": 41,
        "label": "5.2"
      },
      {
        "value": 42,
        "label": "6.0"
      },
      {
        "value": 43,
        "label": "6.1"
      },
      {
        "value": 44,
        "label": "6.2"
      }
    ]
  },
  {
    "parentOlxId": 1079,
    "olxId": 2805,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Hauba"
      },
      {
        "value": 2,
        "label": "Krilo"
      },
      {
        "value": 3,
        "label": "Vrata"
      },
      {
        "value": 4,
        "label": "Gepek"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1085,
    "olxId": 2938,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Hauba"
      },
      {
        "value": 2,
        "label": "Krilo"
      },
      {
        "value": 3,
        "label": "Vrata"
      },
      {
        "value": 4,
        "label": "Bočna"
      },
      {
        "value": 5,
        "label": "Gepek"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1086,
    "olxId": 2940,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Elektronika"
      },
      {
        "value": 2,
        "label": "Prekidač"
      },
      {
        "value": 3,
        "label": "Osigurač"
      },
      {
        "value": 4,
        "label": "Alternator"
      },
      {
        "value": 5,
        "label": "Senzor"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1087,
    "olxId": 2902,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Hauba"
      },
      {
        "value": 2,
        "label": "Krilo"
      },
      {
        "value": 3,
        "label": "Vrata"
      },
      {
        "value": 4,
        "label": "Bočna"
      },
      {
        "value": 5,
        "label": "Gepek"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1088,
    "olxId": 2942,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Elektronika"
      },
      {
        "value": 2,
        "label": "Prekidač"
      },
      {
        "value": 3,
        "label": "Osigurač"
      },
      {
        "value": 4,
        "label": "Alternator"
      },
      {
        "value": 5,
        "label": "Senzor"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1089,
    "olxId": 3218,
    "name": "spol",
    "displayName": "Spol",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi spol"
      },
      {
        "value": 1,
        "label": "Muška"
      },
      {
        "value": 2,
        "label": "Ženska"
      },
      {
        "value": 3,
        "label": "Unisex"
      }
    ]
  },
  {
    "parentOlxId": 1089,
    "olxId": 3208,
    "name": "velicina",
    "displayName": "Veličina",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličinu"
      },
      {
        "value": 1,
        "label": "S"
      },
      {
        "value": 2,
        "label": "M"
      },
      {
        "value": 3,
        "label": "L"
      },
      {
        "value": 4,
        "label": "XL"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1090,
    "olxId": 3216,
    "name": "tip",
    "displayName": "Tip",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi tip"
      },
      {
        "value": 1,
        "label": "Kratki prsti"
      },
      {
        "value": 2,
        "label": "Dugi prsti"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1091,
    "olxId": 7731,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Brzinomjeri "
      },
      {
        "value": 2,
        "label": "Ciklokompjuteri"
      }
    ]
  },
  {
    "parentOlxId": 1433,
    "olxId": 2155,
    "name": "brzine",
    "displayName": "Brzine",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi brzine"
      },
      {
        "value": 1,
        "label": "4"
      },
      {
        "value": 2,
        "label": "5"
      },
      {
        "value": 3,
        "label": "6"
      },
      {
        "value": 4,
        "label": "7"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1433,
    "olxId": 2154,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Automatik"
      },
      {
        "value": 2,
        "label": "Manuelni"
      },
      {
        "value": 3,
        "label": "Poluautomatik"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1434,
    "olxId": 2157,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Zrak"
      },
      {
        "value": 2,
        "label": "Ulje"
      },
      {
        "value": 3,
        "label": "Gorivo"
      },
      {
        "value": 4,
        "label": "Klima"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1435,
    "olxId": 2099,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Prednji"
      },
      {
        "value": 2,
        "label": "Zadnji"
      },
      {
        "value": 3,
        "label": "Centralni"
      },
      {
        "value": 4,
        "label": "Gumeni"
      },
      {
        "value": 5,
        "label": "Druk"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1436,
    "olxId": 2842,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Dizel"
      },
      {
        "value": 2,
        "label": "Benzin"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1438,
    "olxId": 2814,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Dizel"
      },
      {
        "value": 2,
        "label": "Benzin"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1439,
    "olxId": 2127,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Prednja"
      },
      {
        "value": 2,
        "label": "Zadnja"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1440,
    "olxId": 2129,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Prednji"
      },
      {
        "value": 2,
        "label": "Zadnji"
      }
    ]
  },
  {
    "parentOlxId": 1443,
    "olxId": 2134,
    "name": "namjena",
    "displayName": "Namjena",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi namjenu"
      },
      {
        "value": 1,
        "label": "Vozac"
      },
      {
        "value": 2,
        "label": "Suvozac"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1446,
    "olxId": 5078,
    "name": "jacina-ah",
    "displayName": "Kapacitet (Ah)",
    "inputType": "text-range",
    "options": null
  },
  {
    "parentOlxId": 1447,
    "olxId": 2660,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Dizel"
      },
      {
        "value": 2,
        "label": "Benzin"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1448,
    "olxId": 2844,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Elektro"
      },
      {
        "value": 2,
        "label": "Goriva"
      },
      {
        "value": 3,
        "label": "Servo"
      },
      {
        "value": 4,
        "label": "Ulja"
      },
      {
        "value": 5,
        "label": "Vodena"
      },
      {
        "value": 6,
        "label": "Vakum"
      },
      {
        "value": 7,
        "label": "Grijanje"
      },
      {
        "value": 8,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1449,
    "olxId": 7600,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Nosači za automobile"
      },
      {
        "value": 2,
        "label": "Koferi za automobile"
      }
    ]
  },
  {
    "parentOlxId": 1449,
    "olxId": 2826,
    "name": "vrsta",
    "displayName": "Namjena",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi namjenu"
      },
      {
        "value": 1,
        "label": "Krov"
      },
      {
        "value": 2,
        "label": "Gepek"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1449,
    "olxId": 7109,
    "name": "vrsta-oglasa",
    "displayName": "Vrsta oglasa",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta oglasa"
      },
      {
        "value": 1,
        "label": "Prodaja"
      },
      {
        "value": 2,
        "label": "Iznajmljivanje"
      }
    ]
  },
  {
    "parentOlxId": 1450,
    "olxId": 2145,
    "name": "namjena",
    "displayName": "Namjena",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi namjenu"
      },
      {
        "value": 1,
        "label": "Svjetlo"
      },
      {
        "value": 2,
        "label": "Klima"
      },
      {
        "value": 3,
        "label": "Grijanje"
      },
      {
        "value": 4,
        "label": "Ventilacija"
      },
      {
        "value": 5,
        "label": "Podizači"
      },
      {
        "value": 6,
        "label": "Žmigavci"
      },
      {
        "value": 7,
        "label": "Retrovizori"
      },
      {
        "value": 8,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1453,
    "olxId": 2149,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Obična"
      },
      {
        "value": 2,
        "label": "Xenon"
      },
      {
        "value": 3,
        "label": "BiXenon"
      },
      {
        "value": 4,
        "label": "LED"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1454,
    "olxId": 2103,
    "name": "velicina-inch",
    "displayName": "Veličina (inch)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličina (inch)"
      },
      {
        "value": 1,
        "label": "13"
      },
      {
        "value": 2,
        "label": "14"
      },
      {
        "value": 3,
        "label": "15"
      },
      {
        "value": 4,
        "label": "16"
      },
      {
        "value": 5,
        "label": "17"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1455,
    "olxId": 2540,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Sintetička"
      },
      {
        "value": 2,
        "label": "Polusintetička"
      },
      {
        "value": 3,
        "label": "Mineralna ulja"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1456,
    "olxId": 2117,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Prednji desni"
      },
      {
        "value": 2,
        "label": "Zadnji desni"
      },
      {
        "value": 3,
        "label": "Prednji lijevi"
      },
      {
        "value": 4,
        "label": "Zadnji lijevi"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1457,
    "olxId": 2546,
    "name": "boja",
    "displayName": "Boja",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi boju"
      },
      {
        "value": 1,
        "label": "Neutralna"
      },
      {
        "value": 2,
        "label": "Bež"
      },
      {
        "value": 3,
        "label": "Bijela"
      },
      {
        "value": 4,
        "label": "Crna"
      },
      {
        "value": 5,
        "label": "Crvena"
      },
      {
        "value": 6,
        "label": "Ljubičasta"
      },
      {
        "value": 7,
        "label": "Narandžasta"
      },
      {
        "value": 8,
        "label": "Plava"
      },
      {
        "value": 9,
        "label": "Siva"
      },
      {
        "value": 10,
        "label": "Smeđa"
      },
      {
        "value": 11,
        "label": "Srebrena"
      },
      {
        "value": 12,
        "label": "Zelena"
      },
      {
        "value": 13,
        "label": "Zlatna"
      },
      {
        "value": 14,
        "label": "Žuta"
      },
      {
        "value": 15,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1459,
    "olxId": 2552,
    "name": "boja",
    "displayName": "Boja",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi boju"
      },
      {
        "value": 1,
        "label": "Neutralna"
      },
      {
        "value": 2,
        "label": "Bež"
      },
      {
        "value": 3,
        "label": "Bijela"
      },
      {
        "value": 4,
        "label": "Crna"
      },
      {
        "value": 5,
        "label": "Crvena"
      },
      {
        "value": 6,
        "label": "Ljubičasta"
      },
      {
        "value": 7,
        "label": "Narandžasta"
      },
      {
        "value": 8,
        "label": "Plava"
      },
      {
        "value": 9,
        "label": "Siva"
      },
      {
        "value": 10,
        "label": "Smeđa"
      },
      {
        "value": 11,
        "label": "Srebrena"
      },
      {
        "value": 12,
        "label": "Zelena"
      },
      {
        "value": 13,
        "label": "Zlatna"
      },
      {
        "value": 14,
        "label": "Žuta"
      },
      {
        "value": 15,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1459,
    "olxId": 2115,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Prednja desna"
      },
      {
        "value": 2,
        "label": "Zadnja desna"
      },
      {
        "value": 3,
        "label": "Prednja lijeva"
      },
      {
        "value": 4,
        "label": "Zadnja lijeva"
      },
      {
        "value": 5,
        "label": "Gepek vrata"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1460,
    "olxId": 2141,
    "name": "pozicija",
    "displayName": "Pozicija",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi poziciju"
      },
      {
        "value": 1,
        "label": "Prednji"
      },
      {
        "value": 2,
        "label": "Srednji"
      },
      {
        "value": 3,
        "label": "Zadnji"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1460,
    "olxId": 2140,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Za ruku"
      },
      {
        "value": 2,
        "label": "Za glavu"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1461,
    "olxId": 2143,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Gumene"
      },
      {
        "value": 2,
        "label": "Platnene"
      },
      {
        "value": 3,
        "label": "Aluminijske"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1462,
    "olxId": 2105,
    "name": "pozicija",
    "displayName": "Pozicija",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi poziciju"
      },
      {
        "value": 1,
        "label": "Prednji"
      },
      {
        "value": 2,
        "label": "Zadnji"
      },
      {
        "value": 3,
        "label": "Za gepek"
      },
      {
        "value": 4,
        "label": "Za haubu"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1462,
    "olxId": 2570,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Desni"
      },
      {
        "value": 2,
        "label": "Lijevi"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1462,
    "olxId": 2571,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Uljni"
      },
      {
        "value": 2,
        "label": "Gasni"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1469,
    "olxId": 2152,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Klime"
      },
      {
        "value": 2,
        "label": "Vode"
      },
      {
        "value": 3,
        "label": "Zraka"
      },
      {
        "value": 4,
        "label": "Ulja"
      },
      {
        "value": 5,
        "label": "Kabine"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1470,
    "olxId": 2574,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Airbag"
      },
      {
        "value": 2,
        "label": "Radilice"
      },
      {
        "value": 3,
        "label": "Bregaste"
      },
      {
        "value": 4,
        "label": "Temperature"
      },
      {
        "value": 5,
        "label": "Pritiska"
      },
      {
        "value": 6,
        "label": "Zraka"
      },
      {
        "value": 7,
        "label": "Parking"
      },
      {
        "value": 8,
        "label": "Kišu"
      },
      {
        "value": 9,
        "label": "Svjetla"
      },
      {
        "value": 10,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1471,
    "olxId": 2161,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Servo"
      },
      {
        "value": 2,
        "label": "Mehanička"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1472,
    "olxId": 2579,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Desna"
      },
      {
        "value": 2,
        "label": "Lijeva"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1472,
    "olxId": 2107,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Prednji"
      },
      {
        "value": 2,
        "label": "Zadnji"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1473,
    "olxId": 2581,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Procesor"
      },
      {
        "value": 2,
        "label": "Kontroler"
      },
      {
        "value": 3,
        "label": "Pumpa"
      },
      {
        "value": 4,
        "label": "Instalacija"
      },
      {
        "value": 5,
        "label": "Kućište"
      },
      {
        "value": 6,
        "label": "Senzor"
      },
      {
        "value": 7,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1474,
    "olxId": 2585,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Kompletan set"
      },
      {
        "value": 2,
        "label": "Zamajac"
      },
      {
        "value": 3,
        "label": "Lamela"
      },
      {
        "value": 4,
        "label": "Druk ležaj"
      },
      {
        "value": 5,
        "label": "Korpa"
      },
      {
        "value": 6,
        "label": "Cilindar"
      },
      {
        "value": 7,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1475,
    "olxId": 2586,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Analogni"
      },
      {
        "value": 2,
        "label": "Digitalni"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1476,
    "olxId": 2592,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Metal"
      },
      {
        "value": 2,
        "label": "Plastika"
      },
      {
        "value": 3,
        "label": "Guma"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1476,
    "olxId": 2591,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Za ventile"
      },
      {
        "value": 2,
        "label": "Za šarafe"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1477,
    "olxId": 2597,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Usisni"
      },
      {
        "value": 2,
        "label": "EGR"
      },
      {
        "value": 3,
        "label": "Vakum"
      },
      {
        "value": 4,
        "label": "Gas"
      },
      {
        "value": 5,
        "label": "Elektro"
      },
      {
        "value": 6,
        "label": "Zrak"
      },
      {
        "value": 7,
        "label": "Ostaloa"
      }
    ]
  },
  {
    "parentOlxId": 1478,
    "olxId": 2600,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Dizel"
      },
      {
        "value": 2,
        "label": "Benzin"
      },
      {
        "value": 3,
        "label": "Plin"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1479,
    "olxId": 2603,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Metalni"
      },
      {
        "value": 2,
        "label": "Plastični"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1480,
    "olxId": 2150,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Klime"
      },
      {
        "value": 2,
        "label": "Vode"
      },
      {
        "value": 3,
        "label": "Hladnjaka"
      },
      {
        "value": 4,
        "label": "Motora"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1486,
    "olxId": 2098,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Ručna"
      },
      {
        "value": 2,
        "label": "Hidraulična"
      },
      {
        "value": 3,
        "label": "Zračna"
      },
      {
        "value": 4,
        "label": "Mehanička"
      },
      {
        "value": 5,
        "label": "Četverostubna"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1487,
    "olxId": 2096,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Prednji"
      },
      {
        "value": 2,
        "label": "Zadnji"
      },
      {
        "value": 3,
        "label": "Glavni"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1490,
    "olxId": 2111,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Prednje"
      },
      {
        "value": 2,
        "label": "Zadnje"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1505,
    "olxId": 2796,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Lijeva"
      },
      {
        "value": 2,
        "label": "Desna"
      },
      {
        "value": 3,
        "label": "Lijeva i Desna"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1507,
    "olxId": 2521,
    "name": "boja-vecinska",
    "displayName": "Boja (većinska)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi boja (većinska)"
      },
      {
        "value": 1,
        "label": "Crna"
      },
      {
        "value": 2,
        "label": "Crvena"
      },
      {
        "value": 3,
        "label": "Siva"
      },
      {
        "value": 4,
        "label": "Plava"
      },
      {
        "value": 5,
        "label": "Žuta"
      },
      {
        "value": 6,
        "label": "Zelena"
      },
      {
        "value": 7,
        "label": "Smeđa"
      },
      {
        "value": 8,
        "label": "Roza"
      },
      {
        "value": 9,
        "label": "Šareno"
      },
      {
        "value": 10,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1508,
    "olxId": 2522,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Prednja"
      },
      {
        "value": 2,
        "label": "Zadnja"
      },
      {
        "value": 3,
        "label": "Prednja i zadnja"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1509,
    "olxId": 2520,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Analogni"
      },
      {
        "value": 2,
        "label": "Digitalni"
      },
      {
        "value": 3,
        "label": "Analogni i Digitalni"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1510,
    "olxId": 2523,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Koža"
      },
      {
        "value": 2,
        "label": "Skaj"
      },
      {
        "value": 3,
        "label": "Tekstil"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1511,
    "olxId": 2526,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Koža"
      },
      {
        "value": 2,
        "label": "Skaj"
      },
      {
        "value": 3,
        "label": "Tekstil"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1511,
    "olxId": 6901,
    "name": "velicina",
    "displayName": "Veličina",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličinu"
      },
      {
        "value": 1,
        "label": "XXS"
      },
      {
        "value": 2,
        "label": "XS"
      },
      {
        "value": 3,
        "label": "S"
      },
      {
        "value": 4,
        "label": "M"
      },
      {
        "value": 5,
        "label": "L"
      },
      {
        "value": 6,
        "label": "XL"
      },
      {
        "value": 7,
        "label": "XXL"
      },
      {
        "value": 8,
        "label": "XXXL"
      },
      {
        "value": 9,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1512,
    "olxId": 2545,
    "name": "kubikaza-ccm",
    "displayName": "Kubikaža (ccm)",
    "inputType": "text",
    "options": null
  },
  {
    "parentOlxId": 1512,
    "olxId": 2543,
    "name": "vrsta-masine-broj-taktova",
    "displayName": "Vrsta mašine (broj taktova)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta mašine (broj taktova)"
      },
      {
        "value": 1,
        "label": "2T"
      },
      {
        "value": 2,
        "label": "4T"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1522,
    "olxId": 2620,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Metal"
      },
      {
        "value": 2,
        "label": "Plastika"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1524,
    "olxId": 2646,
    "name": "dijelovi",
    "displayName": "Dijelovi",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi dijelovi"
      },
      {
        "value": 1,
        "label": "Regulator"
      },
      {
        "value": 2,
        "label": "Španer"
      },
      {
        "value": 3,
        "label": "Ležaj"
      },
      {
        "value": 4,
        "label": "Presostat"
      },
      {
        "value": 5,
        "label": "Reostat"
      },
      {
        "value": 6,
        "label": "Relej"
      },
      {
        "value": 7,
        "label": "Komplet"
      },
      {
        "value": 8,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1540,
    "olxId": 2529,
    "name": "boja-vecinska",
    "displayName": "Boja (većinska)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi boja (većinska)"
      },
      {
        "value": 1,
        "label": "Bijela"
      },
      {
        "value": 2,
        "label": "Crna"
      },
      {
        "value": 3,
        "label": "Siva"
      },
      {
        "value": 4,
        "label": "Srebrna"
      },
      {
        "value": 5,
        "label": "Zlatna"
      },
      {
        "value": 6,
        "label": "Bež"
      },
      {
        "value": 7,
        "label": "Smeđa"
      },
      {
        "value": 8,
        "label": "Crvena"
      },
      {
        "value": 9,
        "label": "Plava"
      },
      {
        "value": 10,
        "label": "Zelena"
      },
      {
        "value": 11,
        "label": "Žuta"
      },
      {
        "value": 12,
        "label": "Narandžasta"
      },
      {
        "value": 13,
        "label": "Ljubičasta"
      },
      {
        "value": 14,
        "label": "Roza"
      },
      {
        "value": 15,
        "label": "Višebojna"
      },
      {
        "value": 16,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1541,
    "olxId": 2653,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Prednji"
      },
      {
        "value": 2,
        "label": "Zadnji"
      },
      {
        "value": 3,
        "label": "Bočni"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1544,
    "olxId": 3266,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Čelik"
      },
      {
        "value": 2,
        "label": "Aluminij"
      },
      {
        "value": 3,
        "label": "Karbon"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1544,
    "olxId": 3267,
    "name": "velicina",
    "displayName": "Veličina",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličinu"
      },
      {
        "value": 1,
        "label": "XXS"
      },
      {
        "value": 2,
        "label": "XS"
      },
      {
        "value": 3,
        "label": "S"
      },
      {
        "value": 4,
        "label": "M"
      },
      {
        "value": 5,
        "label": "L"
      },
      {
        "value": 6,
        "label": "XL"
      },
      {
        "value": 7,
        "label": "XXL"
      },
      {
        "value": 8,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1544,
    "olxId": 3264,
    "name": "vrsta-bicikla",
    "displayName": "Vrsta bicikla",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta bicikla"
      },
      {
        "value": 1,
        "label": "Brdski (MTB)"
      },
      {
        "value": 2,
        "label": "Cestovni"
      },
      {
        "value": 3,
        "label": "Cross/Trekking"
      },
      {
        "value": 4,
        "label": "Gradski"
      },
      {
        "value": 5,
        "label": "BMX"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1545,
    "olxId": 3269,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Prednja"
      },
      {
        "value": 2,
        "label": "Srednja"
      },
      {
        "value": 3,
        "label": "Zadnja"
      },
      {
        "value": 4,
        "label": "Set"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1546,
    "olxId": 3273,
    "name": "materijal-felge",
    "displayName": "Materijal felge",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal felge"
      },
      {
        "value": 1,
        "label": "Čelična"
      },
      {
        "value": 2,
        "label": "Aluminijska"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1546,
    "olxId": 3277,
    "name": "namjena-vrsta-bicikla",
    "displayName": "Namjena (vrsta bicikla)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi namjena (vrsta bicikla)"
      },
      {
        "value": 1,
        "label": "Brdski (MTB)"
      },
      {
        "value": 2,
        "label": "Cestovni"
      },
      {
        "value": 3,
        "label": "Cross/Trekking"
      },
      {
        "value": 4,
        "label": "Gradski"
      },
      {
        "value": 5,
        "label": "BMX"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1546,
    "olxId": 3272,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Prednji"
      },
      {
        "value": 2,
        "label": "Zadnji"
      },
      {
        "value": 3,
        "label": "Cijeli set"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1546,
    "olxId": 3271,
    "name": "velicina-inch",
    "displayName": "Veličina (inch)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličina (inch)"
      },
      {
        "value": 1,
        "label": "12"
      },
      {
        "value": 2,
        "label": "14"
      },
      {
        "value": 3,
        "label": "16"
      },
      {
        "value": 4,
        "label": "20"
      },
      {
        "value": 5,
        "label": "24"
      },
      {
        "value": 6,
        "label": "26"
      },
      {
        "value": 7,
        "label": "27"
      },
      {
        "value": 8,
        "label": "28"
      },
      {
        "value": 9,
        "label": "29"
      },
      {
        "value": 10,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1547,
    "olxId": 3279,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Prednji"
      },
      {
        "value": 2,
        "label": "Srednji"
      },
      {
        "value": 3,
        "label": "Zadnji"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1548,
    "olxId": 3281,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Prednji"
      },
      {
        "value": 2,
        "label": "Zadnji"
      },
      {
        "value": 3,
        "label": "Cijeli set"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1548,
    "olxId": 3282,
    "name": "velicina-inch",
    "displayName": "Veličina (inch)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličina (inch)"
      },
      {
        "value": 1,
        "label": "12"
      },
      {
        "value": 2,
        "label": "14"
      },
      {
        "value": 3,
        "label": "16"
      },
      {
        "value": 4,
        "label": "20"
      },
      {
        "value": 5,
        "label": "24"
      },
      {
        "value": 6,
        "label": "26"
      },
      {
        "value": 7,
        "label": "27"
      },
      {
        "value": 8,
        "label": "28"
      },
      {
        "value": 9,
        "label": "29"
      },
      {
        "value": 10,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1549,
    "olxId": 3287,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Prednja"
      },
      {
        "value": 2,
        "label": "Zadnja"
      },
      {
        "value": 3,
        "label": "Cijeli set"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1549,
    "olxId": 3285,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Disk"
      },
      {
        "value": 2,
        "label": "V Brake"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1551,
    "olxId": 3291,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Lijeva"
      },
      {
        "value": 2,
        "label": "Desna"
      },
      {
        "value": 3,
        "label": "Lijeva i Desna"
      },
      {
        "value": 4,
        "label": "Dodatne (suvozač)"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1566,
    "olxId": 2195,
    "name": "jacina-w",
    "displayName": "Jačina (W)",
    "inputType": "text-range",
    "options": null
  },
  {
    "parentOlxId": 1567,
    "olxId": 2197,
    "name": "jacina-w",
    "displayName": "Jačina (W)",
    "inputType": "text-range",
    "options": null
  },
  {
    "parentOlxId": 1570,
    "olxId": 2200,
    "name": "broj-izlaza",
    "displayName": "Broj izlaza",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi broj izlaza"
      },
      {
        "value": 1,
        "label": "0"
      },
      {
        "value": 2,
        "label": "1"
      },
      {
        "value": 3,
        "label": "2"
      },
      {
        "value": 4,
        "label": "3"
      },
      {
        "value": 5,
        "label": "4"
      },
      {
        "value": 6,
        "label": "5"
      },
      {
        "value": 7,
        "label": "6"
      },
      {
        "value": 8,
        "label": "7"
      },
      {
        "value": 9,
        "label": "8"
      },
      {
        "value": 10,
        "label": "9"
      },
      {
        "value": 11,
        "label": "10"
      },
      {
        "value": 12,
        "label": "11"
      },
      {
        "value": 13,
        "label": "12"
      },
      {
        "value": 14,
        "label": "13"
      },
      {
        "value": 15,
        "label": "14"
      },
      {
        "value": 16,
        "label": "15"
      },
      {
        "value": 17,
        "label": "16"
      },
      {
        "value": 18,
        "label": "17"
      },
      {
        "value": 19,
        "label": "18"
      }
    ]
  },
  {
    "parentOlxId": 1570,
    "olxId": 2199,
    "name": "jacina-w",
    "displayName": "Jačina (W)",
    "inputType": "text-range",
    "options": null
  },
  {
    "parentOlxId": 1602,
    "olxId": 3298,
    "name": "mjesto-montaze",
    "displayName": "Mjesto montaže",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi mjesto montaže"
      },
      {
        "value": 1,
        "label": "Pod sic"
      },
      {
        "value": 2,
        "label": "Na ram/kostur"
      },
      {
        "value": 3,
        "label": "Na lulu/ručke"
      },
      {
        "value": 4,
        "label": "Na gepek"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1609,
    "olxId": 2555,
    "name": "zapremina-ccm",
    "displayName": "Zapremina (ccm)",
    "inputType": "text-range",
    "options": null
  },
  {
    "parentOlxId": 1610,
    "olxId": 2561,
    "name": "zapremina-l",
    "displayName": "Zapremina (L)",
    "inputType": "text-range",
    "options": null
  },
  {
    "parentOlxId": 1614,
    "olxId": 2707,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Brava"
      },
      {
        "value": 2,
        "label": "Ključ"
      },
      {
        "value": 3,
        "label": "Oklop"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1616,
    "olxId": 5013,
    "name": "broj-rupa",
    "displayName": "Broj rupa",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi broj rupa"
      },
      {
        "value": 1,
        "label": "3"
      },
      {
        "value": 2,
        "label": "4"
      },
      {
        "value": 3,
        "label": "5"
      },
      {
        "value": 4,
        "label": "Više"
      }
    ]
  },
  {
    "parentOlxId": 1616,
    "olxId": 2716,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Čelične"
      },
      {
        "value": 2,
        "label": "Aluminijske"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1616,
    "olxId": 5014,
    "name": "raspon-sarafa",
    "displayName": "Raspon šarafa",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi raspon šarafa"
      },
      {
        "value": 1,
        "label": "4x98"
      },
      {
        "value": 2,
        "label": "4x100"
      },
      {
        "value": 3,
        "label": "4x108"
      },
      {
        "value": 4,
        "label": "4x100/4x108"
      },
      {
        "value": 5,
        "label": "4x112"
      },
      {
        "value": 6,
        "label": "4x114.3"
      },
      {
        "value": 7,
        "label": "4x100/4x114.30"
      },
      {
        "value": 8,
        "label": "4x108/4x113.30"
      },
      {
        "value": 9,
        "label": "4x120"
      },
      {
        "value": 10,
        "label": "5x98"
      },
      {
        "value": 11,
        "label": "5x100"
      },
      {
        "value": 12,
        "label": "5x105"
      },
      {
        "value": 13,
        "label": "5x114.3"
      },
      {
        "value": 14,
        "label": "5x108"
      },
      {
        "value": 15,
        "label": "5x110"
      },
      {
        "value": 16,
        "label": "5x112"
      },
      {
        "value": 17,
        "label": "5x115"
      },
      {
        "value": 18,
        "label": "5x120"
      },
      {
        "value": 19,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1616,
    "olxId": 5012,
    "name": "velicina",
    "displayName": "Veličina",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličinu"
      },
      {
        "value": 1,
        "label": "13"
      },
      {
        "value": 2,
        "label": "14"
      },
      {
        "value": 3,
        "label": "15"
      },
      {
        "value": 4,
        "label": "16"
      },
      {
        "value": 5,
        "label": "17"
      },
      {
        "value": 6,
        "label": "18"
      },
      {
        "value": 7,
        "label": "19"
      },
      {
        "value": 8,
        "label": "20"
      },
      {
        "value": 9,
        "label": "21"
      },
      {
        "value": 10,
        "label": "22"
      },
      {
        "value": 11,
        "label": "23"
      },
      {
        "value": 12,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1616,
    "olxId": 5016,
    "name": "vrsta-gume",
    "displayName": "Vrsta gume",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta gume"
      },
      {
        "value": 1,
        "label": "Ljetne"
      },
      {
        "value": 2,
        "label": "Zimske"
      },
      {
        "value": 3,
        "label": "All season (Cjelogodišnje)"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1617,
    "olxId": 2721,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Prednji"
      },
      {
        "value": 2,
        "label": "Zadnji"
      },
      {
        "value": 3,
        "label": "Bočni"
      },
      {
        "value": 4,
        "label": "Unutrašnji"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1618,
    "olxId": 2724,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Čelik"
      },
      {
        "value": 2,
        "label": "Aluminij"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1618,
    "olxId": 2725,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Desna"
      },
      {
        "value": 2,
        "label": "Lijeva"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1619,
    "olxId": 2731,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Vrata"
      },
      {
        "value": 2,
        "label": "Gepek"
      },
      {
        "value": 3,
        "label": "Krov"
      },
      {
        "value": 4,
        "label": "Patos"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1623,
    "olxId": 2741,
    "name": "namjena",
    "displayName": "Namjena",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi namjenu"
      },
      {
        "value": 1,
        "label": "Unutrašnja"
      },
      {
        "value": 2,
        "label": "Vanjska"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1624,
    "olxId": 2743,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Desna"
      },
      {
        "value": 2,
        "label": "Lijeva"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1627,
    "olxId": 3308,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Alarm"
      },
      {
        "value": 2,
        "label": "Sajla"
      },
      {
        "value": 3,
        "label": "Katanac"
      },
      {
        "value": 4,
        "label": "Zaštita konstrukcije/izrade"
      },
      {
        "value": 5,
        "label": "Zaštite nogu"
      },
      {
        "value": 6,
        "label": "Zaštita ruku"
      },
      {
        "value": 7,
        "label": "Gel"
      },
      {
        "value": 8,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1628,
    "olxId": 3309,
    "name": "broj-karika",
    "displayName": "Broj karika",
    "inputType": "text-range",
    "options": null
  },
  {
    "parentOlxId": 1631,
    "olxId": 3314,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Disk"
      },
      {
        "value": 2,
        "label": "Pakna"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1632,
    "olxId": 3321,
    "name": "sistem-kopcanja-zatvaranja",
    "displayName": "Sistem kopčanja/zatvaranja",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi sistem kopčanja/zatvaranja"
      },
      {
        "value": 1,
        "label": "Čičak"
      },
      {
        "value": 2,
        "label": "Kopča"
      },
      {
        "value": 3,
        "label": "Vez"
      },
      {
        "value": 4,
        "label": "Čičak i kopča"
      },
      {
        "value": 5,
        "label": "Patent kopčanje"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1632,
    "olxId": 3320,
    "name": "spol",
    "displayName": "Spol",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi spol"
      },
      {
        "value": 1,
        "label": "Muške"
      },
      {
        "value": 2,
        "label": "Ženske"
      },
      {
        "value": 3,
        "label": "Unisex"
      }
    ]
  },
  {
    "parentOlxId": 1634,
    "olxId": 3325,
    "name": "mjesto-montaze",
    "displayName": "Mjesto montaže",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi mjesto montaže"
      },
      {
        "value": 1,
        "label": "Pod sic"
      },
      {
        "value": 2,
        "label": "Na ram/kostur"
      },
      {
        "value": 3,
        "label": "Na lulu/ručke"
      },
      {
        "value": 4,
        "label": "Na gepek"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1635,
    "olxId": 3326,
    "name": "mjesto-montaze",
    "displayName": "Mjesto montaže",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi mjesto montaže"
      },
      {
        "value": 1,
        "label": "Ručke/Upravljač"
      },
      {
        "value": 2,
        "label": "Ram"
      },
      {
        "value": 3,
        "label": "Gepek"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1638,
    "olxId": 2562,
    "name": "materijal-vrsta",
    "displayName": "Materijal/Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal/vrsta"
      },
      {
        "value": 1,
        "label": "Čelični"
      },
      {
        "value": 2,
        "label": "Aluminijski"
      },
      {
        "value": 3,
        "label": "Karbonski"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1642,
    "olxId": 3331,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Čelik"
      },
      {
        "value": 2,
        "label": "Aluminij"
      },
      {
        "value": 3,
        "label": "Karbon"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1642,
    "olxId": 3333,
    "name": "prihvat",
    "displayName": "Prihvat",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi prihvat"
      },
      {
        "value": 1,
        "label": "25.4"
      },
      {
        "value": 2,
        "label": "31.8"
      },
      {
        "value": 3,
        "label": "28.6"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1643,
    "olxId": 3334,
    "name": "odgovarajuci-tockovi-inch",
    "displayName": "Odgovarajući točkovi (inch)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi odgovarajući točkovi (inch)"
      },
      {
        "value": 1,
        "label": "12"
      },
      {
        "value": 2,
        "label": "14"
      },
      {
        "value": 3,
        "label": "16"
      },
      {
        "value": 4,
        "label": "20"
      },
      {
        "value": 5,
        "label": "24"
      },
      {
        "value": 6,
        "label": "26"
      },
      {
        "value": 7,
        "label": "27"
      },
      {
        "value": 8,
        "label": "28"
      },
      {
        "value": 9,
        "label": "29"
      },
      {
        "value": 10,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1644,
    "olxId": 3339,
    "name": "namjena",
    "displayName": "Namjena",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi namjenu"
      },
      {
        "value": 1,
        "label": "Za gume"
      },
      {
        "value": 2,
        "label": "Za amortizere"
      },
      {
        "value": 3,
        "label": "Za gume i amortizere"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1644,
    "olxId": 3338,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Ručna"
      },
      {
        "value": 2,
        "label": "Nožna/Podna"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1646,
    "olxId": 2564,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Filter zraka"
      },
      {
        "value": 2,
        "label": "Filter ulja"
      },
      {
        "value": 3,
        "label": "Filter goriva"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1647,
    "olxId": 2565,
    "name": "materijal-vrsta",
    "displayName": "Materijal/Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal/vrsta"
      },
      {
        "value": 1,
        "label": "Čelični"
      },
      {
        "value": 2,
        "label": "Aluminijski"
      },
      {
        "value": 3,
        "label": "Karbonski"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1648,
    "olxId": 2567,
    "name": "materijal-vrsta",
    "displayName": "Materijal/Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal/vrsta"
      },
      {
        "value": 1,
        "label": "Čelični"
      },
      {
        "value": 2,
        "label": "Aluminijski"
      },
      {
        "value": 3,
        "label": "Karbonski"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1649,
    "olxId": 2588,
    "name": "dimenzija-inch-mm",
    "displayName": "Dimenzija inch (mm)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi dimenzija inch (mm)"
      },
      {
        "value": 1,
        "label": "1/2 x 3/16 (12.7 x 4.76)"
      },
      {
        "value": 2,
        "label": "1/2 x 1/4 (12.7 x 6.35)"
      },
      {
        "value": 3,
        "label": "1/2 x 5/16 (12.7 x 7.9)"
      },
      {
        "value": 4,
        "label": "5/8 x 1/4 (15.8 x 6.35)"
      },
      {
        "value": 5,
        "label": "5/8 x 5/16 (15.8 x 7.9)"
      },
      {
        "value": 6,
        "label": "5/8 x 3/8 (15.8 x 9.5)"
      },
      {
        "value": 7,
        "label": "5/8 x 3/8 (15.8 x 9.5)"
      },
      {
        "value": 8,
        "label": "3/4 x 3/8 (19.0 x 9.5)"
      },
      {
        "value": 9,
        "label": "5/8 x 1/4 (15.8 x 9.5)"
      },
      {
        "value": 10,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1649,
    "olxId": 2576,
    "name": "velicina",
    "displayName": "Veličina",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličinu"
      },
      {
        "value": 1,
        "label": "415"
      },
      {
        "value": 2,
        "label": "420"
      },
      {
        "value": 3,
        "label": "428"
      },
      {
        "value": 4,
        "label": "520"
      },
      {
        "value": 5,
        "label": "525"
      },
      {
        "value": 6,
        "label": "530"
      },
      {
        "value": 7,
        "label": "532"
      },
      {
        "value": 8,
        "label": "630"
      },
      {
        "value": 9,
        "label": "632"
      },
      {
        "value": 10,
        "label": "741"
      },
      {
        "value": 11,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1650,
    "olxId": 2596,
    "name": "namijenjeno-za",
    "displayName": "Namijenjeno za",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi namijenjeno za"
      },
      {
        "value": 1,
        "label": "Kilometar sat"
      },
      {
        "value": 2,
        "label": "Kvačilo"
      },
      {
        "value": 3,
        "label": "Gas"
      },
      {
        "value": 4,
        "label": "Kočnice"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1651,
    "olxId": 2601,
    "name": "kapacitet-ah",
    "displayName": "Kapacitet (Ah)",
    "inputType": "text-range",
    "options": null
  },
  {
    "parentOlxId": 1651,
    "olxId": 2606,
    "name": "napon-voltaza-v",
    "displayName": "Napon/Voltaža (V)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi napon/voltaža (v)"
      },
      {
        "value": 1,
        "label": "6V"
      },
      {
        "value": 2,
        "label": "12V"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1652,
    "olxId": 2609,
    "name": "za-masine-broj-taktova",
    "displayName": "Za mašine (broj taktova)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi za mašine (broj taktova)"
      },
      {
        "value": 1,
        "label": "2T"
      },
      {
        "value": 2,
        "label": "4T"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1653,
    "olxId": 2611,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Lijeva"
      },
      {
        "value": 2,
        "label": "Desna"
      },
      {
        "value": 3,
        "label": "Lijeva i desna"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1654,
    "olxId": 2612,
    "name": "vrsta-masine-broj-taktova",
    "displayName": "Vrsta mašine (broj taktova)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta mašine (broj taktova)"
      },
      {
        "value": 1,
        "label": "2T"
      },
      {
        "value": 2,
        "label": "4T"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1656,
    "olxId": 2618,
    "name": "promjer-gume-inch",
    "displayName": "Promjer gume (inch)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi promjer gume (inch)"
      },
      {
        "value": 1,
        "label": "10"
      },
      {
        "value": 2,
        "label": "11"
      },
      {
        "value": 3,
        "label": "12"
      },
      {
        "value": 4,
        "label": "13"
      },
      {
        "value": 5,
        "label": "14"
      },
      {
        "value": 6,
        "label": "15"
      },
      {
        "value": 7,
        "label": "16"
      },
      {
        "value": 8,
        "label": "16.5"
      },
      {
        "value": 9,
        "label": "16/17"
      },
      {
        "value": 10,
        "label": "17"
      },
      {
        "value": 11,
        "label": "17/17"
      },
      {
        "value": 12,
        "label": "18"
      },
      {
        "value": 13,
        "label": "18/17"
      },
      {
        "value": 14,
        "label": "19"
      },
      {
        "value": 15,
        "label": "19/17"
      },
      {
        "value": 16,
        "label": "20"
      },
      {
        "value": 17,
        "label": "21"
      },
      {
        "value": 18,
        "label": "21/17"
      },
      {
        "value": 19,
        "label": "21/18"
      },
      {
        "value": 20,
        "label": "24"
      },
      {
        "value": 21,
        "label": "420"
      },
      {
        "value": 22,
        "label": "90"
      },
      {
        "value": 23,
        "label": "B16"
      },
      {
        "value": 24,
        "label": "B21"
      }
    ]
  },
  {
    "parentOlxId": 1656,
    "olxId": 2623,
    "name": "sirina-gume",
    "displayName": "Širina gume",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi širina gume"
      },
      {
        "value": 1,
        "label": "2.25"
      },
      {
        "value": 2,
        "label": "3.25"
      },
      {
        "value": 3,
        "label": "3"
      },
      {
        "value": 4,
        "label": "2.50"
      },
      {
        "value": 5,
        "label": "2.75"
      },
      {
        "value": 6,
        "label": "4.10"
      },
      {
        "value": 7,
        "label": "3.50"
      },
      {
        "value": 8,
        "label": "4"
      },
      {
        "value": 9,
        "label": "12"
      },
      {
        "value": 10,
        "label": "16"
      },
      {
        "value": 11,
        "label": "60"
      },
      {
        "value": 12,
        "label": "70"
      },
      {
        "value": 13,
        "label": "80"
      },
      {
        "value": 14,
        "label": "90"
      },
      {
        "value": 15,
        "label": "100"
      },
      {
        "value": 16,
        "label": "110"
      },
      {
        "value": 17,
        "label": "120"
      },
      {
        "value": 18,
        "label": "125"
      },
      {
        "value": 19,
        "label": "130"
      },
      {
        "value": 20,
        "label": "140"
      },
      {
        "value": 21,
        "label": "150"
      },
      {
        "value": 22,
        "label": "160"
      },
      {
        "value": 23,
        "label": "165"
      },
      {
        "value": 24,
        "label": "170"
      },
      {
        "value": 25,
        "label": "180"
      },
      {
        "value": 26,
        "label": "190"
      },
      {
        "value": 27,
        "label": "200"
      },
      {
        "value": 28,
        "label": "240"
      },
      {
        "value": 29,
        "label": "245"
      },
      {
        "value": 30,
        "label": "260"
      },
      {
        "value": 31,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1657,
    "olxId": 2626,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Prednji"
      },
      {
        "value": 2,
        "label": "Zadnji"
      },
      {
        "value": 3,
        "label": "Prednji i Zadnji"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1661,
    "olxId": 3341,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Lijeva"
      },
      {
        "value": 2,
        "label": "Desna"
      },
      {
        "value": 3,
        "label": "Komplet (set)"
      }
    ]
  },
  {
    "parentOlxId": 1662,
    "olxId": 2215,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Za kacigu"
      },
      {
        "value": 2,
        "label": "Za motor"
      },
      {
        "value": 3,
        "label": "Za ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1662,
    "olxId": 2631,
    "name": "zatamnjen",
    "displayName": "Zatamnjen",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi zatamnjen"
      },
      {
        "value": 1,
        "label": "Da"
      },
      {
        "value": 2,
        "label": "Ne"
      }
    ]
  },
  {
    "parentOlxId": 1663,
    "olxId": 2634,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Lijevi prednji"
      },
      {
        "value": 2,
        "label": "Desni prednji"
      },
      {
        "value": 3,
        "label": "Lijevi zadnji"
      },
      {
        "value": 4,
        "label": "Desni zadnji"
      },
      {
        "value": 5,
        "label": "Lijevi prednji i zadnji"
      },
      {
        "value": 6,
        "label": "Desni prednji i zadnji"
      },
      {
        "value": 7,
        "label": "Lijevi i Desni (prednji)"
      },
      {
        "value": 8,
        "label": "Lijevi i Desni (zadnji)"
      },
      {
        "value": 9,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1663,
    "olxId": 2635,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Obični"
      },
      {
        "value": 2,
        "label": "LED"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1665,
    "olxId": 2637,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Koža"
      },
      {
        "value": 2,
        "label": "Skaj"
      },
      {
        "value": 3,
        "label": "Tekstil"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1667,
    "olxId": 2649,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Koža"
      },
      {
        "value": 2,
        "label": "Skaj"
      },
      {
        "value": 3,
        "label": "Tekstil"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1667,
    "olxId": 7395,
    "name": "velicina",
    "displayName": "Veličina",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličinu"
      },
      {
        "value": 1,
        "label": "XXS"
      },
      {
        "value": 2,
        "label": "XS"
      },
      {
        "value": 3,
        "label": "S"
      },
      {
        "value": 4,
        "label": "M"
      },
      {
        "value": 5,
        "label": "L"
      },
      {
        "value": 6,
        "label": "XL"
      },
      {
        "value": 7,
        "label": "XXL"
      },
      {
        "value": 8,
        "label": "Univerzalna"
      },
      {
        "value": 9,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1669,
    "olxId": 2657,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Pumpa za benzin/gorivo"
      },
      {
        "value": 2,
        "label": "Pumpa za vodu"
      },
      {
        "value": 3,
        "label": "Pumpa za ulje"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1670,
    "olxId": 2658,
    "name": "vrsta-tip-motocikla",
    "displayName": "Vrsta (Tip motocikla)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta (tip motocikla)"
      },
      {
        "value": 1,
        "label": "Chopper"
      },
      {
        "value": 2,
        "label": "Cruiser"
      },
      {
        "value": 3,
        "label": "Mini bike"
      },
      {
        "value": 4,
        "label": "Moped"
      },
      {
        "value": 5,
        "label": "Enduro / Cross"
      },
      {
        "value": 6,
        "label": "Scooter"
      },
      {
        "value": 7,
        "label": "Naked"
      },
      {
        "value": 8,
        "label": "Touring"
      },
      {
        "value": 9,
        "label": "ATV / Quad"
      },
      {
        "value": 10,
        "label": "Sport"
      },
      {
        "value": 11,
        "label": "Oldtimer"
      },
      {
        "value": 12,
        "label": "SuperMoto"
      },
      {
        "value": 13,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1695,
    "olxId": 2703,
    "name": "ulje-za",
    "displayName": "Ulje za",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi ulje za"
      },
      {
        "value": 1,
        "label": "Motor"
      },
      {
        "value": 2,
        "label": "Kočnice"
      },
      {
        "value": 3,
        "label": "Lanac"
      },
      {
        "value": 4,
        "label": "Viljuške"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1696,
    "olxId": 2705,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Prednja"
      },
      {
        "value": 2,
        "label": "Zadnja"
      },
      {
        "value": 3,
        "label": "Prednja i zadnja"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1703,
    "olxId": 2752,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Čelik"
      },
      {
        "value": 2,
        "label": "Aluminij"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1749,
    "olxId": 2754,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Za motor"
      },
      {
        "value": 2,
        "label": "Za sjedište"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1759,
    "olxId": 2758,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Obični"
      },
      {
        "value": 2,
        "label": "Sekvent"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1765,
    "olxId": 2908,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Dizel"
      },
      {
        "value": 2,
        "label": "Benzin"
      },
      {
        "value": 3,
        "label": "Plin"
      },
      {
        "value": 4,
        "label": "Hibrid"
      },
      {
        "value": 5,
        "label": "Elektro"
      }
    ]
  },
  {
    "parentOlxId": 1766,
    "olxId": 2764,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Čelik"
      },
      {
        "value": 2,
        "label": "Aluminij"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1766,
    "olxId": 2765,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Dizel"
      },
      {
        "value": 2,
        "label": "Benzin"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1768,
    "olxId": 2767,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Dizel"
      },
      {
        "value": 2,
        "label": "Benzin"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1769,
    "olxId": 2946,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Prednji"
      },
      {
        "value": 2,
        "label": "Zadnji"
      },
      {
        "value": 3,
        "label": "Prednji i Zadnji"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1779,
    "olxId": 2947,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Lijevi prednji"
      },
      {
        "value": 2,
        "label": "Desni prednji"
      },
      {
        "value": 3,
        "label": "Lijevi zadnji"
      },
      {
        "value": 4,
        "label": "Desni zadnji"
      },
      {
        "value": 5,
        "label": "Lijevi prednji i zadnji"
      },
      {
        "value": 6,
        "label": "Desni prednji i zadnji"
      },
      {
        "value": 7,
        "label": "Lijevi i Desni (prednji)"
      },
      {
        "value": 8,
        "label": "Lijevi i Desni (zadnji)"
      },
      {
        "value": 9,
        "label": "Komplet"
      },
      {
        "value": 10,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1788,
    "olxId": 2768,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Dizel"
      },
      {
        "value": 2,
        "label": "Benzin"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1789,
    "olxId": 2779,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Metalni"
      },
      {
        "value": 2,
        "label": "Plastični"
      },
      {
        "value": 3,
        "label": "Gumeni"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1789,
    "olxId": 2777,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Motora"
      },
      {
        "value": 2,
        "label": "Vrata"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1804,
    "olxId": 2943,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Gumene"
      },
      {
        "value": 2,
        "label": "Metalne"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1811,
    "olxId": 2785,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Dizel"
      },
      {
        "value": 2,
        "label": "Benzin"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1812,
    "olxId": 2792,
    "name": "grupa",
    "displayName": "Grupa",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi grupa"
      },
      {
        "value": 1,
        "label": "20"
      },
      {
        "value": 2,
        "label": "30"
      },
      {
        "value": 3,
        "label": "40"
      },
      {
        "value": 4,
        "label": "50"
      },
      {
        "value": 5,
        "label": "60"
      },
      {
        "value": 6,
        "label": "70"
      },
      {
        "value": 7,
        "label": "80"
      },
      {
        "value": 8,
        "label": "90"
      },
      {
        "value": 9,
        "label": "95"
      },
      {
        "value": 10,
        "label": "100"
      },
      {
        "value": 11,
        "label": "110"
      },
      {
        "value": 12,
        "label": "120"
      },
      {
        "value": 13,
        "label": "130"
      },
      {
        "value": 14,
        "label": "190"
      },
      {
        "value": 15,
        "label": "200"
      },
      {
        "value": 16,
        "label": "210"
      },
      {
        "value": 17,
        "label": "220"
      },
      {
        "value": 18,
        "label": "225"
      },
      {
        "value": 19,
        "label": "230"
      },
      {
        "value": 20,
        "label": "240"
      },
      {
        "value": 21,
        "label": "245"
      },
      {
        "value": 22,
        "label": "247"
      },
      {
        "value": 23,
        "label": "250"
      },
      {
        "value": 24,
        "label": "260"
      },
      {
        "value": 25,
        "label": "265"
      },
      {
        "value": 26,
        "label": "270"
      },
      {
        "value": 27,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1847,
    "olxId": 2594,
    "name": "broj-zuba",
    "displayName": "Broj zuba",
    "inputType": "text-range",
    "options": null
  },
  {
    "parentOlxId": 1852,
    "olxId": 2956,
    "name": "materijal-vrsta",
    "displayName": "Materijal/Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal/vrsta"
      },
      {
        "value": 1,
        "label": "Metalni"
      },
      {
        "value": 2,
        "label": "Plastični"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1853,
    "olxId": 2957,
    "name": "duzina-m",
    "displayName": "Dužina (m)",
    "inputType": "text-range",
    "options": null
  },
  {
    "parentOlxId": 1853,
    "olxId": 2958,
    "name": "materijal-vrsta",
    "displayName": "Materijal/Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal/vrsta"
      },
      {
        "value": 1,
        "label": "Metal (Lanac)"
      },
      {
        "value": 2,
        "label": "Tkanina"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1854,
    "olxId": 2963,
    "name": "max-opterecenje-kg",
    "displayName": "Max. opterećenje (kg)",
    "inputType": "text-range",
    "options": null
  },
  {
    "parentOlxId": 1854,
    "olxId": 2962,
    "name": "max-visina-doseg-m",
    "displayName": "Max. visina/doseg (m)",
    "inputType": "text-range",
    "options": null
  },
  {
    "parentOlxId": 1857,
    "olxId": 2965,
    "name": "vrsta-za",
    "displayName": "Vrsta/Za",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta/za"
      },
      {
        "value": 1,
        "label": "Elektro"
      },
      {
        "value": 2,
        "label": "Gorivo"
      },
      {
        "value": 3,
        "label": "Servo"
      },
      {
        "value": 4,
        "label": "Ulje"
      },
      {
        "value": 5,
        "label": "Voda"
      },
      {
        "value": 6,
        "label": "Vakum"
      },
      {
        "value": 7,
        "label": "Grijanje"
      },
      {
        "value": 8,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1859,
    "olxId": 3002,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Hladnjak"
      },
      {
        "value": 2,
        "label": "Grijač"
      }
    ]
  },
  {
    "parentOlxId": 1861,
    "olxId": 3006,
    "name": "broj-brzina",
    "displayName": "Broj brzina",
    "inputType": "text-range",
    "options": null
  },
  {
    "parentOlxId": 1861,
    "olxId": 3004,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Automatik"
      },
      {
        "value": 2,
        "label": "Poluautomatik"
      },
      {
        "value": 3,
        "label": "Manuelni"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1863,
    "olxId": 3009,
    "name": "dimenzije-dxsxv",
    "displayName": "Dimenzije (DxŠxV)",
    "inputType": "text",
    "options": null
  },
  {
    "parentOlxId": 1863,
    "olxId": 7112,
    "name": "vrsta-oglasa",
    "displayName": "Vrsta oglasa",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta oglasa"
      },
      {
        "value": 1,
        "label": "Prodaja"
      },
      {
        "value": 2,
        "label": "Iznajmljivanje"
      }
    ]
  },
  {
    "parentOlxId": 1864,
    "olxId": 2979,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Digitalni"
      },
      {
        "value": 2,
        "label": "Analogni"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1866,
    "olxId": 3014,
    "name": "pogon",
    "displayName": "Pogon",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi pogon"
      },
      {
        "value": 1,
        "label": "Hidraulični"
      },
      {
        "value": 2,
        "label": "Kardanski"
      },
      {
        "value": 3,
        "label": "Hidraulični i Kardanski"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1868,
    "olxId": 3017,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Zrak"
      },
      {
        "value": 2,
        "label": "Ulje"
      },
      {
        "value": 3,
        "label": "Gorivo"
      },
      {
        "value": 4,
        "label": "Klima"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1869,
    "olxId": 3019,
    "name": "vrsta-motora",
    "displayName": "Vrsta motora",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta motora"
      },
      {
        "value": 1,
        "label": "Dizel"
      },
      {
        "value": 2,
        "label": "Benzin"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1871,
    "olxId": 2928,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Ljetne"
      },
      {
        "value": 2,
        "label": "Zimske"
      },
      {
        "value": 3,
        "label": "All season"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1872,
    "olxId": 3023,
    "name": "duzina-inch",
    "displayName": "Dužina (inch)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi dužina (inch)"
      },
      {
        "value": 1,
        "label": "11"
      },
      {
        "value": 2,
        "label": "14"
      },
      {
        "value": 3,
        "label": "15"
      },
      {
        "value": 4,
        "label": "16"
      },
      {
        "value": 5,
        "label": "17"
      },
      {
        "value": 6,
        "label": "18"
      },
      {
        "value": 7,
        "label": "19"
      },
      {
        "value": 8,
        "label": "20"
      },
      {
        "value": 9,
        "label": "21"
      },
      {
        "value": 10,
        "label": "22"
      },
      {
        "value": 11,
        "label": "23"
      },
      {
        "value": 12,
        "label": "24"
      },
      {
        "value": 13,
        "label": "26"
      },
      {
        "value": 14,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1872,
    "olxId": 3022,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Prednji"
      },
      {
        "value": 2,
        "label": "Zadnji"
      },
      {
        "value": 3,
        "label": "Komplet prednjih"
      },
      {
        "value": 4,
        "label": "Komplet zadnjih"
      },
      {
        "value": 5,
        "label": "Prednji i Zadnji"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 1879,
    "olxId": 3443,
    "name": "duzina-m",
    "displayName": "Dužina (m)",
    "inputType": "text-range",
    "options": null
  },
  {
    "parentOlxId": 1880,
    "olxId": 5245,
    "name": "snaga-ks",
    "displayName": "Snaga (KS)",
    "inputType": "text-range",
    "options": null
  },
  {
    "parentOlxId": 2012,
    "olxId": 4686,
    "name": "strana",
    "displayName": "Strana",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi stranu"
      },
      {
        "value": 1,
        "label": "Prednji vozačev"
      },
      {
        "value": 2,
        "label": "Prednji suvozačev"
      },
      {
        "value": 3,
        "label": "Zadnji"
      },
      {
        "value": 4,
        "label": "Prednji komplet"
      },
      {
        "value": 5,
        "label": "Prednji i zadnji komplet"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2015,
    "olxId": 4703,
    "name": "sijalica",
    "displayName": "Sijalica",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi sijalica"
      },
      {
        "value": 1,
        "label": "Obična"
      },
      {
        "value": 2,
        "label": "Xenon"
      },
      {
        "value": 3,
        "label": "BiXenon"
      },
      {
        "value": 4,
        "label": "LED"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2015,
    "olxId": 4702,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Desna"
      },
      {
        "value": 2,
        "label": "Lijeva"
      },
      {
        "value": 3,
        "label": "Obje"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2028,
    "olxId": 4730,
    "name": "vrsta-za",
    "displayName": "Vrsta (Za)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta (za)"
      },
      {
        "value": 1,
        "label": "Sjedište"
      },
      {
        "value": 2,
        "label": "Volan"
      },
      {
        "value": 3,
        "label": "Točak"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2062,
    "olxId": 5022,
    "name": "materijal-vecinski",
    "displayName": "Materijal (većinski)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal (većinski)"
      },
      {
        "value": 1,
        "label": "Drvo"
      },
      {
        "value": 2,
        "label": "Plastika"
      },
      {
        "value": 3,
        "label": "Guma"
      },
      {
        "value": 4,
        "label": "Metal"
      },
      {
        "value": 5,
        "label": "Koža"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2094,
    "olxId": 7820,
    "name": "tip",
    "displayName": "Tip",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi tip"
      },
      {
        "value": 1,
        "label": "Mehanizam podizača"
      },
      {
        "value": 2,
        "label": "Motorić podizača"
      },
      {
        "value": 3,
        "label": "Set"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2101,
    "olxId": 7836,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Remenica radilice"
      },
      {
        "value": 2,
        "label": "Remenica alternatora"
      },
      {
        "value": 3,
        "label": "Remenica kompresora klime"
      },
      {
        "value": 4,
        "label": "Remenica servo pumpe"
      },
      {
        "value": 5,
        "label": "Španer zubčastog kaiša"
      },
      {
        "value": 6,
        "label": "Španer mikro remena"
      },
      {
        "value": 7,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2106,
    "olxId": 7834,
    "name": "materijal",
    "displayName": "Materijal",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi materijal"
      },
      {
        "value": 1,
        "label": "Aluminijum"
      },
      {
        "value": 2,
        "label": "Plastika"
      },
      {
        "value": 3,
        "label": "Željezo"
      },
      {
        "value": 4,
        "label": "Karbon"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2128,
    "olxId": 6403,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Motora"
      },
      {
        "value": 2,
        "label": "Mjenjača"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2152,
    "olxId": 7832,
    "name": "vrsta-posude",
    "displayName": "Vrsta posude",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta posude"
      },
      {
        "value": 1,
        "label": "Posuda rashladne tekućine"
      },
      {
        "value": 2,
        "label": "Posuda vode za brisače"
      },
      {
        "value": 3,
        "label": "Posuda kočione tekućine"
      },
      {
        "value": 4,
        "label": "Posuda servo ulja"
      },
      {
        "value": 5,
        "label": "Posuda za Ad Blue"
      },
      {
        "value": 6,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2320,
    "olxId": 7818,
    "name": "vrsta-crijeva",
    "displayName": "Vrsta crijeva",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta crijeva"
      },
      {
        "value": 1,
        "label": "Crijeva za hladnjak"
      },
      {
        "value": 2,
        "label": "Crijeva za gorivo"
      },
      {
        "value": 3,
        "label": "Crijeva za ulje"
      },
      {
        "value": 4,
        "label": "Crijeva turbine"
      },
      {
        "value": 5,
        "label": "Crijeva interkulera"
      },
      {
        "value": 6,
        "label": "Crijeva za vodu"
      },
      {
        "value": 7,
        "label": "Crijeva servo volana"
      },
      {
        "value": 8,
        "label": "Univerzalna crijeva"
      },
      {
        "value": 9,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2322,
    "olxId": 7867,
    "name": "pozicija-diferencijala",
    "displayName": "Pozicija diferencijala",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi pozicija diferencijala"
      },
      {
        "value": 1,
        "label": "Prednji"
      },
      {
        "value": 2,
        "label": "Zadnji"
      },
      {
        "value": 3,
        "label": "Centralni"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2328,
    "olxId": 7837,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Relej grijača"
      },
      {
        "value": 2,
        "label": "Relej pumpe goriva"
      },
      {
        "value": 3,
        "label": "Relej alternatora"
      },
      {
        "value": 4,
        "label": "Relej akumulatora"
      },
      {
        "value": 5,
        "label": "Relej ventilatora"
      },
      {
        "value": 6,
        "label": "Relej žmigavaca i štopke"
      },
      {
        "value": 7,
        "label": "Relej klime"
      },
      {
        "value": 8,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2350,
    "olxId": 7886,
    "name": "broj-kamera",
    "displayName": "Broj kamera",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi broj kamera"
      },
      {
        "value": 1,
        "label": "Prednja"
      },
      {
        "value": 2,
        "label": "Rikverc"
      },
      {
        "value": 3,
        "label": "Unutrašnja"
      },
      {
        "value": 4,
        "label": "Set Prednja i Rikverc"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2393,
    "olxId": 7858,
    "name": "vrsta-kedera",
    "displayName": "Vrsta kedera",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta kedera"
      },
      {
        "value": 1,
        "label": "Vrata"
      },
      {
        "value": 2,
        "label": "Gepeka"
      },
      {
        "value": 3,
        "label": "Haube"
      },
      {
        "value": 4,
        "label": "Prozora"
      },
      {
        "value": 5,
        "label": "Univerzalni keder"
      },
      {
        "value": 6,
        "label": "Keder za zvučnu izolaciju"
      },
      {
        "value": 7,
        "label": "Keder za vjetrobranska stakla"
      }
    ]
  },
  {
    "parentOlxId": 2425,
    "olxId": 6670,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Gasa"
      },
      {
        "value": 2,
        "label": "Kvačila"
      },
      {
        "value": 3,
        "label": "Kočnice"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2456,
    "olxId": 6717,
    "name": "vrsta-zastite",
    "displayName": "Vrsta zaštite",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta zaštite"
      },
      {
        "value": 1,
        "label": "Poklopac"
      },
      {
        "value": 2,
        "label": "Podna zaštita"
      }
    ]
  },
  {
    "parentOlxId": 2458,
    "olxId": 6725,
    "name": "vrsta-pojasa",
    "displayName": "Vrsta pojasa",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta pojasa"
      },
      {
        "value": 1,
        "label": "Prednji"
      },
      {
        "value": 2,
        "label": "Zadnji"
      }
    ]
  },
  {
    "parentOlxId": 2459,
    "olxId": 6729,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Prednji"
      },
      {
        "value": 2,
        "label": "Zadnji"
      }
    ]
  },
  {
    "parentOlxId": 2460,
    "olxId": 7851,
    "name": "vrsta-spule",
    "displayName": "Vrsta špule",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta špule"
      },
      {
        "value": 1,
        "label": "Standardna špula"
      },
      {
        "value": 2,
        "label": "Špula sa tempomatom"
      },
      {
        "value": 3,
        "label": "Špula s modulom"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2472,
    "olxId": 7865,
    "name": "vrsta-biraca",
    "displayName": "Vrsta birača",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta birača"
      },
      {
        "value": 1,
        "label": "Komplet"
      },
      {
        "value": 2,
        "label": "Samo ručica"
      },
      {
        "value": 3,
        "label": "Samo sajle/mehanizak"
      },
      {
        "value": 4,
        "label": "Okvir"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2483,
    "olxId": 6848,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Baglame vrata"
      },
      {
        "value": 2,
        "label": "Zakačke vrata"
      },
      {
        "value": 3,
        "label": "Klizači vrata"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2491,
    "olxId": 6785,
    "name": "namjena",
    "displayName": "Namjena",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi namjenu"
      },
      {
        "value": 1,
        "label": "Ecu motora"
      },
      {
        "value": 2,
        "label": "Ecu mjenjača"
      },
      {
        "value": 3,
        "label": "Ecu volana"
      },
      {
        "value": 4,
        "label": "Ecu vrata"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2501,
    "olxId": 7852,
    "name": "tip-balasta",
    "displayName": "Tip Balasta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi tip balasta"
      },
      {
        "value": 1,
        "label": "HID/Xenon"
      },
      {
        "value": 2,
        "label": "Led"
      },
      {
        "value": 3,
        "label": "Halogen"
      },
      {
        "value": 4,
        "label": "OEM"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2517,
    "olxId": 6817,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Poklopac rezervoara"
      },
      {
        "value": 2,
        "label": "Čep rezervoara"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2518,
    "olxId": 6819,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Šprice(brizgaljke) farova"
      },
      {
        "value": 2,
        "label": "Brisači farova"
      },
      {
        "value": 3,
        "label": "Motorići farova"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2549,
    "olxId": 6876,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Sirena"
      },
      {
        "value": 2,
        "label": "Taster"
      },
      {
        "value": 3,
        "label": "Komplet"
      },
      {
        "value": 4,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2558,
    "olxId": 7872,
    "name": "tip-sijalice",
    "displayName": "Tip sijalice",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi tip sijalice"
      },
      {
        "value": 1,
        "label": "LED"
      },
      {
        "value": 2,
        "label": "Halogena"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2580,
    "olxId": 7855,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Blende"
      },
      {
        "value": 2,
        "label": "Okviri"
      },
      {
        "value": 3,
        "label": "Maskice"
      }
    ]
  },
  {
    "parentOlxId": 2587,
    "olxId": 6947,
    "name": "vrsta-opreme",
    "displayName": "Vrsta opreme",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta opreme"
      },
      {
        "value": 1,
        "label": "Autofolija"
      },
      {
        "value": 2,
        "label": "Alat za postavljanje folije"
      },
      {
        "value": 3,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2598,
    "olxId": 7870,
    "name": "tip-vakuma",
    "displayName": "Tip vakuma",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi tip vakuma"
      },
      {
        "value": 1,
        "label": "Vakum regulatora"
      },
      {
        "value": 2,
        "label": "Vaktum aktuator"
      },
      {
        "value": 3,
        "label": "Vakum ventil"
      },
      {
        "value": 4,
        "label": "Vakum pumpa"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2623,
    "olxId": 6971,
    "name": "vrsta",
    "displayName": "Vrsta",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrstu"
      },
      {
        "value": 1,
        "label": "Prednji desni"
      },
      {
        "value": 2,
        "label": "Zadnji desni"
      },
      {
        "value": 3,
        "label": "Prednji lijevi"
      },
      {
        "value": 4,
        "label": "Zadnji lijevi"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2644,
    "olxId": 7871,
    "name": "vrsta-modula",
    "displayName": "Vrsta modula",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi vrsta modula"
      },
      {
        "value": 1,
        "label": "Centralni modul"
      },
      {
        "value": 2,
        "label": "Modul bočnog airbaga"
      },
      {
        "value": 3,
        "label": "Modul zavjesa"
      },
      {
        "value": 4,
        "label": "Modul airbaga koljena"
      },
      {
        "value": 5,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2661,
    "olxId": 7294,
    "name": "broj-rupa",
    "displayName": "Broj rupa",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi broj rupa"
      },
      {
        "value": 1,
        "label": "3"
      },
      {
        "value": 2,
        "label": "4"
      },
      {
        "value": 3,
        "label": "5"
      },
      {
        "value": 4,
        "label": "Više"
      }
    ]
  },
  {
    "parentOlxId": 2661,
    "olxId": 7295,
    "name": "raspon-sarafa",
    "displayName": "Raspon šarafa",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi raspon šarafa"
      },
      {
        "value": 1,
        "label": "4x98"
      },
      {
        "value": 2,
        "label": "4x100"
      },
      {
        "value": 3,
        "label": "4x108"
      },
      {
        "value": 4,
        "label": "4x100/4x108"
      },
      {
        "value": 5,
        "label": "4x112"
      },
      {
        "value": 6,
        "label": "4x114.3"
      },
      {
        "value": 7,
        "label": "4x100/4x114.30"
      },
      {
        "value": 8,
        "label": "4x108/4x113.30"
      },
      {
        "value": 9,
        "label": "4x120"
      },
      {
        "value": 10,
        "label": "5x98"
      },
      {
        "value": 11,
        "label": "5x100"
      },
      {
        "value": 12,
        "label": "5x105"
      },
      {
        "value": 13,
        "label": "5x114.3"
      },
      {
        "value": 14,
        "label": "5x108"
      },
      {
        "value": 15,
        "label": "5x110"
      },
      {
        "value": 16,
        "label": "5x112"
      },
      {
        "value": 17,
        "label": "5x115"
      },
      {
        "value": 18,
        "label": "5x120"
      },
      {
        "value": 19,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2661,
    "olxId": 7292,
    "name": "sirina",
    "displayName": "Širina",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi širina"
      },
      {
        "value": 1,
        "label": "125"
      },
      {
        "value": 2,
        "label": "135"
      },
      {
        "value": 3,
        "label": "145"
      },
      {
        "value": 4,
        "label": "155"
      },
      {
        "value": 5,
        "label": "165"
      },
      {
        "value": 6,
        "label": "175"
      },
      {
        "value": 7,
        "label": "185"
      },
      {
        "value": 8,
        "label": "195"
      },
      {
        "value": 9,
        "label": "205"
      },
      {
        "value": 10,
        "label": "215"
      },
      {
        "value": 11,
        "label": "225"
      },
      {
        "value": 12,
        "label": "235"
      },
      {
        "value": 13,
        "label": "245"
      },
      {
        "value": 14,
        "label": "255"
      },
      {
        "value": 15,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2661,
    "olxId": 7290,
    "name": "velicina-precnikpromjer",
    "displayName": "Veličina (prečnik/promjer)",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi veličina (prečnik/promjer)"
      },
      {
        "value": 1,
        "label": "13"
      },
      {
        "value": 2,
        "label": "14"
      },
      {
        "value": 3,
        "label": "15"
      },
      {
        "value": 4,
        "label": "16"
      },
      {
        "value": 5,
        "label": "17"
      },
      {
        "value": 6,
        "label": "18"
      },
      {
        "value": 7,
        "label": "19"
      },
      {
        "value": 8,
        "label": "20"
      },
      {
        "value": 9,
        "label": "21"
      },
      {
        "value": 10,
        "label": "22"
      },
      {
        "value": 11,
        "label": "Ostalo"
      }
    ]
  },
  {
    "parentOlxId": 2661,
    "olxId": 7291,
    "name": "visina",
    "displayName": "Visina",
    "inputType": "select",
    "options": [
      {
        "value": 0,
        "label": "Izaberi visina"
      },
      {
        "value": 1,
        "label": "25"
      },
      {
        "value": 2,
        "label": "30"
      },
      {
        "value": 3,
        "label": "35"
      },
      {
        "value": 4,
        "label": "40"
      },
      {
        "value": 5,
        "label": "45"
      },
      {
        "value": 6,
        "label": "50"
      },
      {
        "value": 7,
        "label": "55"
      },
      {
        "value": 8,
        "label": "60"
      },
      {
        "value": 9,
        "label": "65"
      },
      {
        "value": 10,
        "label": "Ostalo"
      }
    ]
  }
];

export { allAttributes };
export default allAttributes;
